import { Component, OnInit, ElementRef, ViewChild, Injectable  } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
// import * as moment from 'moment';
// import Swal from 'sweetalert2';
// import { NgxSpinnerService } from "ngx-spinner";
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import {NgbModal, ModalDismissReasons, NgbModalOptions} from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import * as $ from 'jquery';
import { CommonEventService } from '../services/common-event.service';
import { ApiService } from '../services/api.service';

import { CookieService } from 'ngx-cookie-service';

declare function imageZoom(a: any,b: any,c: any):any;
@Injectable()

@Component({
  selector: 'app-board-details',
  templateUrl: './board-details.component.html',
  styleUrls: ['./board-details.component.css']
})
export class BoardDetailsComponent {
  personalForm: FormGroup;
  boardDetailsForm:FormGroup;
  closeResult: string = '';
  checkAll:any;
  boardDetailList:any= {};
  boardAsArraySelected:boolean=false;
  solderMaskSeclectedYes:boolean=true;
  silkScreenSeclectedYes:boolean=true;
  // selectedLayerVal:any;
  partDataResponse:any={};
  formatCurrency:any;
  isReadOnly:boolean=false;
  hideInnerLayerContent:boolean=false;
  boardDetailLabeltooltips =[
    {name:'1',value:'<b>Part Number </b>Internal identification number (Part#) for the board'},
    {name:'2',value:'<b>Layers</b>:Number of layers your circuit board has <br><br>NOTE: We can display online prices for a maximum of 12 layers, <b>but the best price is available for up to 8 layers.</b> Offline, our sales team can get you prices for up to 50 layer boards'},
    {name:'3',value:'<b>You can get the best price if boards are not setup as arrays</b><br><br><b>Arrays</b>:In rare cases, a PCB designer will put together multiple images of the same PCB together into one image. Such grouping of circuits is called an Array.  This may be done to facilitate easy assembly of the PCBs, etc.<br><br>The individual boards may be separated by tabs( made using Route & Retain OR Scoring processes). For an Array, you must tell us overall array dimensions X and Y, and also number of boards in the array. You must also specify the dimensions of the individual PCB (which combined together make up the array).<br><br>Note that for quoting, you must specify how many individual boards you need (NOT how many arrays). Example: Say each array has 5 boards and you need 4 arrays, then during quoting you must specify a quantity of 20.'},
    {name:'4',value:'<b>Route and Retain</b>: (Also known as  Tab-rout) Tabs routed between each PCB for break-a-way. Unless otherwise noted, we use 100 mil (0.1") spacing between boards'},
    {name:'5',value:'<b>Material Type</b>: Types of laminate available for PCB fabrication'},
    {name:'6',value:'<b>Min. Hole Size</b>: Smallest finished hole size in inches.'},
    {name:'7',value:'<b>Surface Finish</b>: <br><u>HASL</u>: also called Leaded Solder: 63/37 Tin/lead solder application.<br>Immersion Silver: 12-15 microinches of silver.This is also a lead-free finish.<br><br><u>Immersion Gold</u>: 3-10 microinches of gold over electroless nickel (ENIG).This is also a lead-free finish.<br><br><u>Hard Gold</u>: also called Deep Gold: Electrolytic gold plating finish.This is also a lead-free finish.<br><br><u>Soft Gold</u>: 99% pure, 30-100 microinches of gold (Wire Bondable Gold).This is also a lead-free finish.'},
    {name:'8',value:'<b>Min. Trace (Outer layer)</b>: Minimum trace width and spacing, expressed in mils. Select the nearest lower value to the value you want to set as minimum trace for outer layer.'},
    {name:'9',value:'<b>Outer Layer Finish Copper</b>: Max Number of ounces of copper per square foot on outer layers. Specify this as "finished" copper weight. 1 oz is most commonly used weight.'},
    {name:'10',value:'<b>Scoring</b>: V-groove cut into both the top and bottom of the boards for break-away'},
    {name:'11',value:'<b>Thickness</b>: The total thickness of the board including all plating and final finishes'},
    {name:'12',value:'<b>Number of Holes Per Board</b>: This is important because a board with too much hole density is complex and takes a lot of resources on the drilling machine. If your board has more than 80 holes/square inch on the average, you may not get an online quote, and a sales person may need to get involved.'},
    {name:'13',value:'<b>Gold Fingers</b>: Select whether your board has gold fingers. For online quoted PCBs, we always bevel the gold fingers.Our standard bevel is 30 degrees X .020"  +/- .005.'},
    {name:'14',value:'<b>Min Space (Outer layer)</b>: Minimum trace width and spacing, expressed in mils. Select the nearest lower value to the value you want to set as minimum space for outer layer.'},
    {name:'15',value:'<b>Solder Mask Sides</b>: Sides to mask'},
    {name:'16',value:'<b>Solder Mask Color</b>: Color of mask used to cover the PCB'},
    {name:'17',value:'<b>Solder Mask Type</b>: For online quoting we only offer LPI (Liquid Photo-Imageable) solder mask which is sufficient for most PCBs.<br>For finer features, you can ask get Laser Direct Imaging LPI (LDI-LPI) through a custom quote from our sales team. <br>Note that other kinds of solder mask (e.g. Dry Film) are now increasingly obsolete.'},
    {name:'18',value:'<b>Solder Mask Finish</b>: Typically, soldermask has a Semi-gloss finish; but Matte finish can be done for an extra charge.'},
    {name:'19',value:'<b>Silk Screen Sides</b>: Specify whether your design has Legend on Top or Bottom or Both sides?'},
    {name:'20',value:'<b>Silk Screen Color</b>: Color of ink printed on the board. Typically, it is White.'},
    {name:'21',value:'<b>Allow Vendor Markings on board</b>:Vendor markings include Company Logo, UL marking, Flammability, etc. Such vendor markings will be put in Silkscreen/Legend. If silkscreen layer is not present, markings will be put in copper layer.'},
    {name:'22',value:'<b>Controlled Impedance</b>: Specifying the cross-sectional area of a trace(s) and dielectric spacing to achieve a specific resistance Choose the impedance tolerance 5% or 10%. 10% means "10% or more" If less than 5% choose "Other"'},
    {name:'23',value:'<b>IMPORTANT: Regarding Critical Program Info/ Anti Tamper Provisions/ USML Categories/ ECCNs</b>:The Customer understands and acknowledges that non-U.S. persons will have access to the technical data subject in any files that are part of a request for quotation, quotation, order, change order, or purchase order and represents that the Customer reviewed the technical data and it does not contain any Critical Program Information (\'CPI\') within the meaning of Department of Defense (\'DoD\') Instruction 5200.39 or require Anti-Tamper (\'AT\') protections within the meaning of DoD Directive 5200.47E. If any of the technical data references or otherwise identifies U.S. Government systems or programs, the Customer will remove the references and/or identifiers, or will clearly mark the technical data in a conspicuous place.<br><br>For the avoidance of doubt, CPI is defined as U.S. capability elements that contribute to the warfighters\' technical advantage, which if compromised, undermines U.S. military preeminence. U.S. capability elements may include, but are not limited to, software algorithms and specific hardware residing on the system, its training equipment, or maintenance support equipment, and AT is defined as systems engineering activities intended to prevent or delay exploitation of CPI in U.S. defense systems in domestic and export configurations to impede countermeasure development, unintended technology transfer, or alteration of a system due to reverse engineering.<br><br>The Customer further understands and acknowledges that the Customer must provide the correct United States Munitions List (\'USML\') category of the International Traffic in Arms Regulations (22 C.F.R.  § 120) and/or Export Control Classification Number (\'ECCN\') under the Commerce Control List of the Export Administration Regulations (15 C.F.R.  § 774, Supp. No. 1), for the technical data sent and indicate whether the technical data was self-classified or classified by an agency determination.'},
    {name:'24',value:'<b>Allow RoHS Marking</b>:Yes - Put in RoHS marking if applicable (Recommended!)<br>No - Do not put any RoHS marking, even if applicable."'},
    {name:'25',value:'<b>Internal Slots/ Internal Cutouts</b>: Elongated holes used for component placement. These can be plated with copper or non-plated. For online quoting we allow up to 10 slots, cutouts, and notches per board. See details and restrictions in product page https://www.protoexpress.com/kb/web-pcb-specs'},
    {name:'26',value:'<b>Electrical Testing</b>: We provide 100% Electrical Netlist Testing of PCBs for an extra charge.  You can decline testing for PCBs up to 6 layers. If your PCB has more than 6 layers, Electrical Testing is mandatory.'},
    {name:'27', value:'<b>Minimum Trace (Inner layer)</b>: Minimum trace width and spacing, expressed in mils. Select the nearest lower value to the value you want to set as minimum trace for inner layer.'},
    {name:'28', value:'<b>Inner Copper Weight</b>: Copper thickness required on inner layer cores'},
    {name:'29', value:'<b>Minimum Space (Inner layer)</b>: Minimum trace width and spacing, expressed in mils. Select the nearest lower value to the value you want to set as minimum space for inner layer.'},
    {name:'30', value:'<b>Counter Sink</b>: A beveled hole opening allowing a screw head to fit flush with the surface.'},
    {name:'31', value:'<b>Density</b>: This is important because a board with too much hole density is complex and takes a lot of resources on the drilling machine. If your board has more than 80 holes/square inch on the average, you may not get an automatic quote on WEb PCBs prommotion, and a sales person may need to get involved'},
    {name:'32',value:'<b>Minimum Annular Ring</b>: Smallest Annular Ring(Pad Size - Hole Size / 2'},
    {name:'33', value:'<b>Revision </b>: Specifying the revision of your design file is recommended.'},
    {name:'34', value:'<b>Individual Board Dimensions (inches) </b>: Length and Breadth measurements of the board in inches '},
    {name:'35', value:'<b>Flex / Rigid-Flex Board? </b>: Is your board flex or rigid-flex? <br> <b>NOTE :</b> We cannot provide online prices for flex / rigid-flex boards. Offline, our sales team can get prices for such boards.'},
    {name:'36', value:'<b>Blind / Buried vias? </b>: Does your board have blind or buried vias? <br ><b>NOTE :</b> We cannot provide online prices for boards with blind/burried vias. Offline, our sales team can get prices for such boards.'},
    {name:'37', value:'<b>Solder Mask </b>: A thin polymer layer applied to a PCB to protect copper traces and prevent solder from flowing to unwanted areas. It provides protection against oxidation and to prevent solder bridges from forming between closely spaced solder pads.'},
    {name:'38',value:'<b>Silk Screen </b>: Reference characters to designate part locations '},
    {name:'39', value:'<b>Quantity of Individual Boards </b>: You must specify how many individual boards you need (NOT how many arrays). <br>If your boards are setup as an array, you must specify total number of individual boards. Example : Say each array has 5 boards and you need 4 arrays, then during quoting you must specify a quantity of 20.'},
    {name:'40', value:'<b>Boards per Array </b>: Number of boards in the array'},
    {name:'41', value:'<b>Array Dimension </b>: Length and Breadth measurements of array in inches'}
  ];
  layersImg:string='';
  boardAsArrayImg:string='';
  flexRigidBoardImg:string='';
  blindBuriedImg:string='';
  routeAndRetainImg:string='';
  boardMaterialImg:string='';
  minHoleSizeImg:string='';
  surfaceFinishImg:string='';
  scoringImg:string = '';
  boardThicknessImg:string='';
  noOfHolesPerBoardsImg:string='';
  goldFingersImg:string='';
  maxFinishCopperWeightImg : string = '';
  minimumTraceImg : string = '';
  minimumSpaceImg : string = '';
  innerMinimumTraceImg : string = '';
  innerMaxFinishCopperWeightImg : string = '';
  innerMinimumSpaceImg : string = '';
  solderMaskImg : string = '';
  silkScreenImg : string = '';
  allowVendorMarkingImg : string = '';
  controlledImpedanceImg : string = '';
  itarSitchImg : string = '';
  rohsImg : string = '';
  internalSlotsCutOutImg : string = '';
  boardDimensionImg : string = '';
  quantityOfIndividualBoardsImg : string = '';
  boardsPerArrayImg : string = '';
  solderMaskSidesImg : string = '';
  solderMaskColorImg : string = '';
  solderMaskTypesImg  : string = '';
  solderMaskFinishImg : string = '';
  silkScreenSidesImg : string = '';
  silkScreenColorImg : String = '';
  counterSinkImg : string = '';
  boardPerArrayDimensionImg : string = '';
  indBoardXDimValueEmpty : boolean = false;
  productsData:any={};
  indBoardDefaultXDim :any;
  indBoardDefaultYDim :any;
  arrayDefaultXDim:any;
  arrayDefaultYDim:any;
  boardDefaultQty1:any;
  boardDefaultQty2:any;
  boardDefaultQty3:any;
  boardDefaultQty4:any;
  extractedPcbSpecification:any=[];
  defaultPcbSpecification:any=[];
  updatedPcbSpecification:any=[];
  finalExtractedPcbSpecification:any=[];
  finalDefaultPcbSpecification:any=[];
  finalUpdatedPcbSpecification:any=[];
  currentDateTime:any;
  fileReuploadedOnBoardDetails:boolean=false;
  domain: string = '';
  isValid: boolean = false;
  flowActivityId:any='';
  densityImg:any='Default_icon';
  minAnnularRingImg:any='Default_icon';
  internalSlotsCutOutCountImg:any='Default_icon';

  @ViewChild("userEmail") userEmail!: ElementRef ;
  @ViewChild("boardDimensionX") boardDimensionX!: ElementRef ;
  @ViewChild("boardDimensionY") boardDimensionY!: ElementRef ;
  @ViewChild("boardPerArray") boardPerArray!: ElementRef ;
  @ViewChild("arrayDimensionX") arrayDimensionX!: ElementRef;
  @ViewChild("arrayDimensionY") arrayDimensionY!: ElementRef;
  @ViewChild("noOfHolesPerBoard") noOfHolesPerBoard!: ElementRef;
  @ViewChild("itarYes") itarYes!: ElementRef;
  @ViewChild("itarNo") itarNo!: ElementRef; 
  @ViewChild("NumberofLayers") numberofLayers!: ElementRef;
  @ViewChild("boardQty1") boardQtyOne!: ElementRef;
  @ViewChild("boardQty2") boardQtyTwo!: ElementRef;
  @ViewChild("boardQty3") boardQtyThree!: ElementRef;
  @ViewChild("boardQty4") boardQtyFour!: ElementRef;
 
  constructor(
    public ngb : NgbModule,
    private formBuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    public apiService : ApiService,
    public commonService : CommonEventService,
    private cookieSer : CookieService
  ){
  
    //Below regex satisfy all the conditions
    //Validators.pattern('^[a-zA-Z0-9._%+-]+@(?!(?:.*-[0-9]+\.)(?=.*[0-9]$))[a-zA-Z0-9-]{1,61}[a-zA-Z0-9]\.(?![0-9]+$)[a-zA-Z0-9]{2,63}$')
    this.personalForm = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email, Validators.minLength(1)]),
    });
    this.boardDetailsForm = new FormGroup({
      partNumber: new FormControl('', [Validators.required, Validators.minLength(1),Validators.maxLength(50)]),
      revision: new FormControl('', [Validators.required,Validators.minLength(1), Validators.maxLength(10)]),
      dimensionX:new FormControl('', [Validators.required,Validators.minLength(1), Validators.maxLength(6)]),
      dimensionY:new FormControl('', [Validators.required,Validators.minLength(1), Validators.maxLength(6)]),
      boardsPerArray:new FormControl('', [Validators.required,Validators.minLength(1), Validators.maxLength(10000)]),
      arrayDimensionX:new FormControl('', [Validators.required,Validators.minLength(1), Validators.maxLength(6)]),
      arrayDimensionY:new FormControl('', [Validators.required,Validators.minLength(1), Validators.maxLength(6)]),
      noOfHolesPerBoard:new FormControl('', [Validators.required,Validators.minLength(80)]),
      boardQty1:new FormControl('', [Validators.required, Validators.minLength(1),Validators.maxLength(10)]),
      boardQty2:new FormControl('', [Validators.required,Validators.minLength(1),Validators.maxLength(10)]),
      boardQty3:new FormControl('', [Validators.required,Validators.minLength(1), Validators.maxLength(10)]),
      boardQty4:new FormControl('', [Validators.required,Validators.minLength(1),Validators.maxLength(10)]),
      controlledImpedance : new FormControl('', [Validators.required]),
      layers : new FormControl('', [Validators.required]),
      boardMaterial : new FormControl('', [Validators.required]),
      minHoleSize : new FormControl('', [Validators.required]),
      surfaceFinish : new FormControl('', [Validators.required]),
      minimumTrace : new FormControl('', [Validators.required]),
      maxFinishCopperWeight : new FormControl('', [Validators.required]),
      boardThickness : new FormControl('', [Validators.required]),
      minimumSpace : new FormControl('', [Validators.required]),
      solderMaskSides : new FormControl('', [Validators.required]),
      solderMaskColor : new FormControl('', [Validators.required]),
      solderMaskTypes : new FormControl('', [Validators.required]),
      solderMaskFinish : new FormControl('', [Validators.required]),
      silkScreenSides : new FormControl('', [Validators.required]),
      silkScreenColor : new FormControl('', [Validators.required]),
      internalSlotsCutOut : new FormControl('', [Validators.required]),
      innerMinimumSpace: new FormControl('', [Validators.required]),
      innerMinimumTrace : new FormControl('', [Validators.required]),
      innerMaxFinishCopperWeight : new FormControl('', [Validators.required]),
      silkScreenMethod : new FormControl('', [Validators.required]),
      minAnnularRing: new FormControl('', [Validators.required]),
      density: new FormControl('', [Validators.required]),
      internalSlotsCutOutCount: new FormControl('', [Validators.required])
    });
    
  }
  
  validateDomain(): void {
    this.domain = this.boardDetailList.email;
    this.commonService.validateDomain(this.domain);
    setTimeout(() => {
      this.isValid = this.commonService.commonMainObj.invalidEmail;
    }, 500);
  }

  login_validation_messages = {
    'email': [
      { type: 'required', message: 'Email is required.' },
      { type: 'minlength', message: 'Email must be at least 1 characters long.' },
      { type: 'maxlength', message: 'Email cannot be more than 25 characters long.' },
      //{ type: 'pattern', message: 'Please enter a valid email.' }
    ]
  }

  board_details_validation_messages={
    'dimensionX':[
      { type: 'required', message: 'Enter value for length' },
      
    ],
    'dimensionY':[
      { type: 'required', message: 'Enter value for breadth' },
      
    ],
    'noOfHolesPerBoard':[
      { type: 'required', message: 'Please enter Number of Holes Per Board.' },
      
    ],
    'arrayDimensionX':[
      { type: 'required', message: 'Enter length for array' },
    ],
    'arrayDimensionY':[
      { type: 'required', message: 'Enter breadth for array' },
    ],
    'boardsPerArray':[
      { type: 'required', message: "Enter value for 'Boards per array'"},
    ],
    'minAnnularRing' :[
      { type: 'required', message: "Enter value for 'Minimum Annular Ring'"},
    ],
    'density':[
      { type: 'required', message: "Enter value for 'Density'"},
    ],
    'internalSlotsCutOutCount':[
      { type: 'required', message: "Enter value for 'Internal Cutout Counts'"},
    ]
  }
  
  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.commonService.restrictBrowserButtons();
    this.commonService.restrictRefreshButton();
    this.commonService.formattingCurrentDateTime();
    if(this.commonService.commonMainObj.fileUploadedData.topImage && this.commonService.commonMainObj.fileUploadedData.topImageHeight >100 && this.commonService.commonMainObj.fileUploadedData.topImageWidth >100){
      setTimeout(()=>{
        imageZoom("pcbImg1", "mypcbImgResult",this.commonService.commonMainObj.fileUploadedData.topImage);  
      },500);
    }
    if(this.commonService.commonMainObj.fileUploadedData.botImage && this.commonService.commonMainObj.fileUploadedData.botImageHeight >100 && this.commonService.commonMainObj.fileUploadedData.botImageWidth >100){
      setTimeout(()=>{
        imageZoom("pcbImg2", "mypcbImgResult",this.commonService.commonMainObj.fileUploadedData.botImage);  
      },500);
    }
    if(this.commonService.commonMainObj.userData.registrationEmail){
      this.isReadOnly = true;
    }else{
      this.isReadOnly = false;
    }
    this.boardDetailList.email  = this.commonService.commonMainObj.userData.registrationEmail ? this.commonService.commonMainObj.userData.registrationEmail:'';
    
    this.commonService.sessionPortalLoad();
    this.commonService.loadingShow();
    this.apiService.createPartData(this.commonService.commonMainObj.uploadedFilesData.partNumber,this.commonService.commonMainObj.uploadedFilesData.partRevision,this.commonService.commonMainObj.uploadedFilesData.filename).subscribe((res: any)=>{
      setTimeout(()=>{
        $('.pcb_img_top').css({'width': this.commonService.commonMainObj.fileUploadedData.topImageWidth>240?240:this.commonService.commonMainObj.fileUploadedData.topImageWidth + 'px','height': this.commonService.commonMainObj.fileUploadedData.topImageHeight>250?250:this.commonService.commonMainObj.fileUploadedData.topImageHeight + 'px'});
        $('.pcb_img_bottom').css({'width': this.commonService.commonMainObj.fileUploadedData.botImageWidth>240?240:this.commonService.commonMainObj.fileUploadedData.botImageWidth + 'px','height': this.commonService.commonMainObj.fileUploadedData.botImageHeight>250?250:this.commonService.commonMainObj.fileUploadedData.botImageHeight + 'px'});
      },500);
        if(res){
          this.commonService.loadingHide();
            this.partDataResponse= res;
            this.productsData = res;
            this.commonService.commonMainObj.pcbPartData = res;
            for (var quoteInputGroup of this.partDataResponse.products[0].quoteInputGroups) {
                for (var quoteInput of quoteInputGroup.quoteInputs) {
                  if(quoteInput.inputName == 'partRevision'){
                    this.boardDetailList.revision = quoteInput.valueMap;
                  }
                  if(quoteInput.inputName == 'partNumber'){
                    this.boardDetailList.partNumber = quoteInput.valueMap;
                  }
                  if(quoteInput.inputName == 'noOfHolesPerBoard'){
                    if(quoteInput.default != '' && quoteInput.default != null && quoteInput.default != "0"){
                      this.boardDetailList.noOfHolesPerBoard=quoteInput.default;
                      if(quoteInput.isExtracted == true){
                        $('#numberOfHolesTotipHide').show();
                        this.noOfHolesPerBoardsImg = "Extracted_icon";
                      }else{
                        $('#numberOfHolesTotipHide').hide();
                        this.noOfHolesPerBoardsImg = "Default_icon";
                      }
                    }
                    
                  }
                  if(quoteInput.inputName == 'indBoardXDim'){
                    if(quoteInput.default == '' || quoteInput.default == null || quoteInput.default == "0"){
                      this.indBoardXDimValueEmpty = true;
                    }
                    if(quoteInput.default != '' && quoteInput.default != null && quoteInput.default != "0"){
                      this.boardDetailList.dimensionX=quoteInput.default;
                      this.truncateToThreeDecimals(this.boardDetailList.dimensionX,'this.boardDetailList.dimensionX');
                      this.indBoardDefaultXDim = quoteInput.default;
                      if(quoteInput.isExtracted == true){
                        this.boardDimensionImg = "Extracted_icon";
                      }else{
                        this.boardDimensionImg = "Default_icon";
                      }
                    }
                  }
                  if(quoteInput.inputName == 'indBoardYDim'){
                    if((quoteInput.default == '' || quoteInput.default == null || quoteInput.default == "0") && this.indBoardXDimValueEmpty){
                      $('#IndividualDimensionLableHide').hide();
                    }else{
                      $('#IndividualDimensionLableHide').show();
                    }
                    if(quoteInput.default != '' && quoteInput.default != null && quoteInput.default != "0"){
                      this.boardDetailList.dimensionY=quoteInput.default;
                      this.truncateToThreeDecimals(this.boardDetailList.dimensionY,'this.boardDetailList.dimensionY');
                      this.indBoardDefaultYDim = quoteInput.default;
                      if(quoteInput.isExtracted == true){
                        this.boardDimensionImg = "Extracted_icon";
                      }else{
                        this.boardDimensionImg = "Default_icon";
                      }
                    }
                  }
                  if(quoteInput.inputName == 'blindburiedvias'){
                    if(quoteInput.default == 0){
                      this.blindBuriedSelectedNo();
                    }else if(quoteInput.default == 1){
                      this.blindBuriedSelectedYes();
                    }else{
                      this.blindBuriedSelectedNo();
                    }
                    if(quoteInput.isExtracted == true){
                      this.blindBuriedImg = "Extracted_icon"
                    }else{
                      this.blindBuriedImg = "Default_icon";
                    }
                  }
                  if(quoteInput.inputName == 'flexRigidFlex'){
                    if(quoteInput.default == 0){
                      this.rigidFlexBoardNo();
                    }else if(quoteInput.default == 1){
                      this.rigidFlexBoardYes();
                    }else{
                      this.rigidFlexBoardNo();
                    }
                    if(quoteInput.isExtracted == true){
                      this.flexRigidBoardImg = "Extracted_icon";
                    }else{
                      this.flexRigidBoardImg = "Default_icon";;
                    }
                  }
                  if(quoteInput.inputName == 'drillHolesDensity'){
                    if(quoteInput.default != '' && quoteInput.default != null){
                      this.boardDetailList.density = quoteInput.default;
                      if(quoteInput.isExtracted == true){
                        // $('#densityTooltip').show();
                        this.densityImg = "Extracted_icon";
                      }else{
                        // $('#densityTooltip').hide();
                        this.densityImg = "Default_icon";
                      }
                    }
                  }
                  if(quoteInput.inputName == 'drillHolesMinimumAnnularRing'){
                    if(quoteInput.default != '' && quoteInput.default != null){
                      this.boardDetailList.minAnnularRingDiv=quoteInput.default;
                      if(quoteInput.isExtracted == true){
                        // $('#minAnnularRingTooltip').show();
                        this.minAnnularRingImg = "Extracted_icon";
                      }else{
                        // $('#minAnnularRingTooltip').hide();
                        this.minAnnularRingImg = "Default_icon";
                      }
                    }
                  }
                  if(quoteInput.inputName == 'slots'){
                    if(quoteInput.default != '' && quoteInput.default != null){
                      this.boardDetailList.internalSlotsCutOutCount=quoteInput.default;
                      if(quoteInput.isExtracted == true){
                        // $('#internalSlotsCutOutCountTooltip').show();
                        this.internalSlotsCutOutCountImg = "Extracted_icon";
                      }else{
                        // $('#internalSlotsCutOutCountTooltip').hide();
                        this.internalSlotsCutOutCountImg = "Default_icon";
                      }
                    }
                  }
                  switch (quoteInput.dataType) {
                    case 'integer(int32)':
                    case 'float':
                    if (quoteInput.valueMap) {
                      for (var vm in quoteInput.valueMap) {
                          if(quoteInput.inputName == 'layers'){
                            if(quoteInput.default == vm){
                                this.boardDetailList.layers=vm;
                                $('#numOfLayersIndicateDiv').show();
                                if(quoteInput.isExtracted == true){
                                  this.layersImg = "Extracted_icon";
                                }else{
                                  this.layersImg = "Default_icon";
                                }
                            }
                            if(quoteInput.default == '' || quoteInput.default == null || quoteInput.default == '1'){
                              this.boardDetailList.layers=1;
                              $('#numOfLayersIndicateDiv').hide();
                            }
                            $('#NumofLayers').append($("<option></option>").attr("value",vm).text(quoteInput.valueMap[vm]));
                          }
                          if(quoteInput.inputName == 'material'){ 
                            if(quoteInput.default == vm){
                                this.boardDetailList.boardMaterial=quoteInput.valueMap[vm];
                                if(quoteInput.isExtracted == true){
                                  this.boardMaterialImg = "Extracted_icon";
                                }else{
                                  this.boardMaterialImg = "Default_icon";
                                }
                            }
                            $('#boardMaterial').append($("<option></option>").attr("value",quoteInput.valueMap[vm]).text(quoteInput.valueMap[vm])); 
                          }
                          if(quoteInput.inputName == 'finishedThickness'){
                            if(quoteInput.default == vm){
                                this.boardDetailList.boardThickness=quoteInput.valueMap[vm];
                                if(quoteInput.isExtracted == true){
                                  this.boardThicknessImg = "Extracted_icon";
                                }else{
                                  this.boardThicknessImg = "Default_icon";
                                }
                            }
                            $('#boardThickness').append($("<option></option>").attr("value",quoteInput.valueMap[vm]).text(quoteInput.valueMap[vm]));
                          }
                          if(quoteInput.inputName == 'minHoleSize'){
                            if(quoteInput.default == vm){
                                this.boardDetailList.minHoleSize=quoteInput.valueMap[vm];
                                if(quoteInput.isExtracted == true){
                                  this.minHoleSizeImg = "Extracted_icon";
                                }else{
                                  this.minHoleSizeImg = "Default_icon";
                                }
                            }
                            $('#minHoleSize').append($("<option></option>").attr("value",quoteInput.valueMap[vm]).text(quoteInput.valueMap[vm]));
                          }
                          if(quoteInput.inputName == 'surfaceFinish'){
                            if(quoteInput.default == vm){
                                this.boardDetailList.surfaceFinish =quoteInput.valueMap[vm];
                                if(quoteInput.isExtracted == true){
                                  this.surfaceFinishImg = "Extracted_icon";
                                }else{
                                  this.surfaceFinishImg = "Default_icon";
                                }
                            }
                            $('#surfaceFinish').append($("<option></option>").attr("value",quoteInput.valueMap[vm]).text(quoteInput.valueMap[vm]));
                          }
                          if(quoteInput.inputName == 'minimumTrace'){
                            if(quoteInput.default == vm){
                                this.boardDetailList.minimumTrace=quoteInput.valueMap[vm];
                                if(quoteInput.isExtracted == true){
                                  this.minimumTraceImg = "Extracted_icon";
                                }else{
                                  this.minimumTraceImg = "Default_icon";
                                }
                            }
                            $('#minimumTrace').append($("<option></option>").attr("value",quoteInput.valueMap[vm]).text(quoteInput.valueMap[vm]));
                          }
                          if(quoteInput.inputName == 'minimumSpace'){
                            if(quoteInput.default == vm){
                                this.boardDetailList.minimumSpace=quoteInput.valueMap[vm];
                                if(quoteInput.isExtracted == true){
                                  this.minimumSpaceImg = "Extracted_icon";
                                }else{
                                  this.minimumSpaceImg = "Default_icon";
                                }
                            }
                            $('#minimumSpace').append($("<option></option>").attr("value",quoteInput.valueMap[vm]).text(quoteInput.valueMap[vm]));
                          }
                          if(quoteInput.inputName == 'outerLyrFinishCopper'){
                            if(quoteInput.default == vm){
                                this.boardDetailList.maxFinishCopperWeight=quoteInput.valueMap[vm];
                                if(quoteInput.isExtracted == true){
                                  this.maxFinishCopperWeightImg = "Extracted_icon";
                                }else{
                                  this.maxFinishCopperWeightImg = "Default_icon";
                                }
                            }
                            $('#maxFinishCopperWeight').append($("<option></option>").attr("value",quoteInput.valueMap[vm]).text(quoteInput.valueMap[vm]));
                          }
                          if(quoteInput.inputName == 'minimumTraceInnerLyr'){
                            if(quoteInput.default == vm){
                                this.boardDetailList.innerMinimumTrace=quoteInput.valueMap[vm];
                                if(quoteInput.isExtracted == true){
                                  this.innerMinimumTraceImg = "Extracted_icon";
                                }else{
                                  this.innerMinimumTraceImg = "Default_icon";
                                }
                            }
                            $('#innerMinimumTrace').append($("<option></option>").attr("value",quoteInput.valueMap[vm]).text(quoteInput.valueMap[vm]));
                          }
                          if(quoteInput.inputName == 'minimumSpaceInnerLyr'){
                            if(quoteInput.default == vm){
                                this.boardDetailList.innerMinimumSpace=quoteInput.valueMap[vm];
                                if(quoteInput.isExtracted == true){
                                  this.innerMinimumSpaceImg = "Extracted_icon";
                                }else{
                                  this.innerMinimumSpaceImg = "Default_icon";
                                }
                            }
                            $('#innerMinimumSpace').append($("<option></option>").attr("value",quoteInput.valueMap[vm]).text(quoteInput.valueMap[vm]));
                          }
                          if(quoteInput.inputName == 'innerLyrFinishCopper'){
                            if(quoteInput.default == vm){
                                this.boardDetailList.innerMaxFinishCopperWeight=quoteInput.valueMap[vm];
                                if(quoteInput.isExtracted == true){
                                  this.innerMaxFinishCopperWeightImg = "Extracted_icon";
                                }else{
                                  this.innerMaxFinishCopperWeightImg = "Default_icon";
                                }
                            }
                            if(quoteInput.default == null){
                              this.boardDetailList.innerMaxFinishCopperWeight="1 Oz";
                              if(quoteInput.isExtracted == true){
                                this.innerMaxFinishCopperWeightImg = "Extracted_icon";
                              }else{
                                this.innerMaxFinishCopperWeightImg = "Default_icon";
                              }
                            }
                            $('#innerMaxFinishCopperWeight').append($("<option></option>").attr("value",quoteInput.valueMap[vm]).text(quoteInput.valueMap[vm]));
                          }
                          if(quoteInput.inputName == 'solderMaskSides'){
                            if(quoteInput.default == vm){
                                this.boardDetailList.solderMaskSides=quoteInput.valueMap[vm];
                                if(quoteInput.isExtracted == true){
                                  this.solderMaskSidesImg = "Extracted_icon";
                                }else{
                                  this.solderMaskSidesImg = "Default_icon";
                                }
                            }
                            $('#solderMaskSides').append($("<option></option>").attr("value",quoteInput.valueMap[vm]).text(quoteInput.valueMap[vm]));
                          }
                          if(quoteInput.inputName == 'solderMaskType'){
                            if(quoteInput.default == vm){
                                this.boardDetailList.solderMaskTypes=quoteInput.valueMap[vm];
                                
                                if(quoteInput.isExtracted == true){
                                  this.solderMaskTypesImg = "Extracted_icon";
                                }else{
                                  this.solderMaskTypesImg = "Default_icon";
                                }
                                //extracted
                            }else if(quoteInput.default == null){
                              this.boardDetailList.solderMaskTypes="LPI";
                              //default
                              this.solderMaskTypesImg = "Default_icon";
                            }
                            $('#solderMaskTypes').append($("<option></option>").attr("value",quoteInput.valueMap[vm]).text(quoteInput.valueMap[vm]));
                          }
                          if(quoteInput.inputName == 'solderMaskColor'){
                            if(quoteInput.default == vm){
                                this.boardDetailList.solderMaskColor=quoteInput.valueMap[vm];
                                if(quoteInput.isExtracted == true){
                                  this.solderMaskColorImg = "Extracted_icon";
                                }else{
                                  this.solderMaskColorImg = "Default_icon";
                                }
                            }else if(quoteInput.default == null){
                              this.boardDetailList.solderMaskColor="Green";
                              this.solderMaskColorImg = "Default_icon";
                              // defoult
                            }
                            $('#solderMaskColor').append($("<option></option>").attr("value",quoteInput.valueMap[vm]).text(quoteInput.valueMap[vm]));
                          }
                          if(quoteInput.inputName == 'solderMaskFinish'){
                            if(quoteInput.default == vm){
                                this.boardDetailList.solderMaskFinish=quoteInput.valueMap[vm];
                                if(quoteInput.isExtracted == true){
                                  this.solderMaskFinishImg = "Extracted_icon";
                                }else{
                                  this.solderMaskFinishImg = "Default_icon";
                                }
                            }
                            $('#solderMaskFinish').append($("<option></option>").attr("value",quoteInput.valueMap[vm]).text(quoteInput.valueMap[vm]));
                          }
                          if(quoteInput.inputName == 'silkScreenSides'){
                            if(quoteInput.default == vm){
                              this.boardDetailList.silkScreenSides=quoteInput.valueMap[vm];
                              if(quoteInput.isExtracted == true){
                                this.silkScreenSidesImg = "Extracted_icon";
                              }else{
                                this.silkScreenSidesImg = "Default_icon";
                              }
                            }
                            if(quoteInput.default == null){
                              this.boardDetailList.silkScreenSides=quoteInput.valueMap[2];
                              this.silkScreenSidesImg = "Default_icon";
                            }
                            $('#silkScreenSides').append($("<option></option>").attr("value",quoteInput.valueMap[vm]).text(quoteInput.valueMap[vm]));
                          }
                          if(quoteInput.inputName == 'silkScreenColor'){
                            if(quoteInput.default == vm){
                                this.boardDetailList.silkScreenColor=quoteInput.valueMap[vm];
                                if(quoteInput.isExtracted == true){
                                  this.silkScreenColorImg = "Extracted_icon";
                                }else{
                                  this.silkScreenColorImg = "Default_icon";
                                }
                            }else if(quoteInput.default == null){
                              this.boardDetailList.silkScreenColor="White";
                              this.silkScreenColorImg = "Default_icon";
                              // defoult
                            }
                            $('#silkScreenColor').append($("<option></option>").attr("value",quoteInput.valueMap[vm]).text(quoteInput.valueMap[vm]));
                          }
                          if(quoteInput.inputName == 'slotsCutouts'){
                            if(quoteInput.default == vm){
                                this.boardDetailList.internalSlotsCutOut=quoteInput.valueMap[vm];
                                if(quoteInput.isExtracted == true){
                                  this.internalSlotsCutOutImg = "Extracted_icon";
                                }else{
                                  this.internalSlotsCutOutImg = "Default_icon";
                                }
                            }
                            $('#internalSlotsCutOut').append($("<option></option>").attr("value",quoteInput.valueMap[vm]).text(quoteInput.valueMap[vm]));
                          }
                          if(quoteInput.inputName == 'controlledImpedance'){
                            if(quoteInput.default == vm){
                                this.boardDetailList.controlledImpedance=quoteInput.valueMap[vm];
                                if(quoteInput.isExtracted == true){
                                  this.controlledImpedanceImg = "Extracted_icon";
                                }else{
                                  this.controlledImpedanceImg = "Default_icon";
                                }
                            }
                            $('#controlledImpedance').append($("<option></option>").attr("value",quoteInput.valueMap[vm]).text(quoteInput.valueMap[vm]));
                          }
                          if(quoteInput.inputName == 'solderMask'){
                            if( quoteInput.default == 1){
                              this.solderMaskSelectedYes();
                              // this.solderMaskImg = "Extracted_icon";
                            }
                            else if(quoteInput.default == 0){
                              this.solderMaskSelectedNo();
                              // this.solderMaskImg = "Extracted_icon";
                            }
                            if(quoteInput.isExtracted == true){
                              this.solderMaskImg = "Extracted_icon";
                            }else{
                              this.solderMaskImg = "Default_icon";
                            }
                          }
                          if(quoteInput.inputName == 'silkScreen'){
                            if( quoteInput.default == 1){
                              this.silkScreenIsSeclectedYes();
                            }else if( quoteInput.default == 0){
                              this.silkScreenIsSeclectedNo();
                            }
                            if(quoteInput.isExtracted == true){
                              this.silkScreenImg = "Extracted_icon";
                            }else{
                              this.silkScreenImg = "Default_icon";
                            }
                          }
                          if(quoteInput.inputName == 'routeAndRetain'){
                            if(quoteInput.default == 1){
                              this.routeAndRetainSelectedYes();
                            }
                            else if(quoteInput.default == 0){
                              this.routeAndRetainSelectedNo(); 
                            }
                            if(quoteInput.isExtracted == true){
                              this.routeAndRetainImg = "Extracted_icon";
                              
                            }else if(quoteInput.isExtracted == false){
                              this.routeAndRetainImg = "Default_icon"; 
                            }                          
                          }
                          if(quoteInput.inputName == 'scoring'){
                            if(quoteInput.default == 1){
                              this.scoringSelectedYes();
                            }else if(quoteInput.default == 0){
                              this.scoringSelectedNo();
                            }
                            if(quoteInput.isExtracted == true){
                              this.scoringImg = "Extracted_icon";
                            }else{
                              this.scoringImg = "Default_icon";
                            }
                          }
                          if(quoteInput.inputName == 'goldFingers'){
                            if(quoteInput.default == 1){
                              this.goldFingerSelectedYes();
                            }
                            else if(quoteInput.default == 0){
                              this.goldFingerSelectedNo();
                            } 
                            if(quoteInput.isExtracted == true){
                              this.goldFingersImg = "Extracted_icon";
                            }else{
                              this.goldFingersImg = "Default_icon";
                            }
                          }
                          if(quoteInput.inputName == 'thruHoleViainPad'){
                            if(quoteInput.default == 1){
                              $('#viaInPadsNo').removeClass('active');
                              $('#viaInPadsNo').removeClass('btn-green');
                              $('#viaInPadsNo').addClass('btn-gray');
                              $('#viaInPadsYes').removeClass('btn-gray');
                              $('#viaInPadsYes').addClass('active');
                              $('#viaInPadsYes').addClass('btn-green');
                            }
                            else if(quoteInput.default == 0){
                              $('#viaInPadsYes').removeClass('active');
                              $('#viaInPadsYes').removeClass('btn-green');
                              $('#viaInPadsYes').addClass('btn-gray');
                              $('#viaInPadsNo').removeClass('btn-gray');
                              $('#viaInPadsNo').addClass('active');
                              $('#viaInPadsNo').addClass('btn-green');
                            }
                          }
                          if(quoteInput.inputName == 'roHSMarking'){
                            if(quoteInput.default == 1){
                              this.roHSMarkingSelectedYes();
                            }
                            if(quoteInput.default == 0){
                              this.roHSMarkingSelectedNo();
                            } 
                            if(quoteInput.isExtracted == true){
                              this.rohsImg = "Extracted_icon";
                            }else{
                              this.rohsImg = "Default_icon";
                            }
                          }
                          if(quoteInput.inputName == 'vendorMarking'){
                            if(quoteInput.default == 1){
                              this.vendorMarkingSelectedYes();
                            }
                            if(quoteInput.default == 0){
                              this.vendorMarkingSelectedNo();
                            }
                            if(quoteInput.isExtracted == true){
                              this.allowVendorMarkingImg = "Extracted_icon";
                            }else{
                              this.allowVendorMarkingImg = "Default_icon";
                            }
                          }
                          if(quoteInput.inputName == 'counterSink'){
                            // this.boardDetailList.counterSink = quoteInput.default
                            if(quoteInput.default == 0){
                              this.counterSinkSelectedNo();
                            }else if(quoteInput.default == 1){
                              this.counterSinkSelectedYes();
                            }else{
                              this.counterSinkSelectedNo();
                            }
                            if(quoteInput.isExtracted == true){
                              this.counterSinkImg = "Extracted_icon";
                            }else{
                              this.counterSinkImg = "Default_icon";
                            }
                          }
                          if(quoteInput.inputName == 'electricalTesting'){
                            if(quoteInput.default == 1){
                              $('#electricalTestingNo').removeClass('active');
                              $('#electricalTestingNo').removeClass('btn-green');
                              $('#electricalTestingNo').addClass('btn-gray');
                              $('#electricalTestingYes').removeClass('btn-gray');
                              $('#electricalTestingYes').addClass('active');
                              $('#electricalTestingYes').addClass('btn-green');
                            }
                            else if(quoteInput.default == 0){
                              $('#electricalTestingYes').removeClass('active');
                              $('#electricalTestingYes').removeClass('btn-green');
                              $('#electricalTestingYes').addClass('btn-gray');
                              $('#electricalTestingNo').removeClass('btn-gray');
                              $('#electricalTestingNo').addClass('active');
                              $('#electricalTestingNo').addClass('btn-green');
                            } 
                          }
                          if(quoteInput.inputName == 'arrays'){
                              if(quoteInput.default == 0){
                                this.boardAsArraySelectedNo(); 
                                if(quoteInput.isExtracted){
                                  this.boardsPerArrayImg = "Extracted_icon";
                                }else{
                                  this.boardsPerArrayImg = "Default_icon";
                                }
                              }else if(quoteInput.default == 1){
                                this.boardAsArraySelectedYes();
                                if(quoteInput.isExtracted){
                                  this.boardsPerArrayImg = "Extracted_icon";
                                }else{
                                  this.boardsPerArrayImg = "Default_icon";
                                }
                              }
                          }
                      }
                    }
                  }
                }
            }
            
            if($('#boardAsArrayNo').hasClass('active')){
              if(this.commonService.commonMainObj.backToBoardDetails){
                this.boardDetailList.boardQty1 = this.commonService.commonMainObj.boardDetailsDataObj.boardQty1;
                this.boardDetailList.boardQty2 = this.commonService.commonMainObj.boardDetailsDataObj.boardQty2;
                this.boardDefaultQty1 = this.commonService.commonMainObj.boardDetailsDataObj.boardQty1;
                this.boardDefaultQty2 = this.commonService.commonMainObj.boardDetailsDataObj.boardQty2;
                this.boardDetailList.boardQty3 = '15';
                this.boardDetailList.boardQty4 = '20';
              }else{
                this.boardDetailList.boardQty1 = '5';
                this.boardDetailList.boardQty2 = '10';
                this.boardDefaultQty1 = '5';
                this.boardDefaultQty2 = '10';
                this.boardDetailList.boardQty3 = '15';
                this.boardDetailList.boardQty4 = '20';
                this.boardDefaultQty3 = '15';
                this.boardDefaultQty4 = '20';
              }
              this.boardAsArrayImg = "Default_icon";
              this.quantityOfIndividualBoardsImg = "Default_icon";
            }
            if((this.boardDetailList.surfaceFinish == "Immersion Silver" || this.boardDetailList.surfaceFinish == "hard gold" || this.boardDetailList.surfaceFinish == "ENIG")){
              // $('#rohsYes').prop("disabled",false);
              // $('#rohsToolTip').hide();
            }else{
              // $('#rohsYes').prop("disabled",true);
              // $('#rohsToolTip').show();
              // if( $('#rohsYes').hasClass('active')){
              //   $('#rohsYes').removeClass('active');
              //   $('#rohsYes').removeClass('btn-green');
              //   $('#rohsYes').addClass('btn-gray');
              //   $('#rohsNo').removeClass('btn-gray');
              //   $('#rohsNo').removeClass('active');
              //   $('#rohsNo').addClass('btn-green');
              // }
            }
            if((this.boardDetailList.boardMaterial == "FR4- lead free" || this.boardDetailList.boardMaterial == "Nan Ya NP-175")){
              // $('#rohsYes').prop("disabled",false);
              // $('#rohsToolTip').hide();
            }else{
              // $('#rohsYes').prop("disabled",true);
              // $('#rohsToolTip').show();
              // if( $('#rohsYes').hasClass('active')){
              //   $('#rohsYes').removeClass('active');
              //   $('#rohsYes').removeClass('btn-green');
              //   $('#rohsYes').addClass('btn-gray');
              //   $('#rohsNo').removeClass('btn-gray');
              //   $('#rohsNo').removeClass('active');
              //   $('#rohsNo').addClass('btn-green');
              // }
            }
            if(this.boardDetailList.layers - 1 > 2){
              this.hideInnerLayerContent=false;
            }else{
              this.hideInnerLayerContent=true;
            }
            var selectedMaterial = this.boardDetailList.boardMaterial;
            var selectedSurface = this.boardDetailList.surfaceFinish;
            if((selectedMaterial == "FR4- lead free" || selectedMaterial == "Nan Ya NP-175") && (selectedSurface == "Immersion Silver" || selectedSurface == "Lead Free HASL" || selectedSurface == "hard gold")){
              // $('#rohsYes').prop("disabled",false);
            }else{
              // $('#rohsYes').prop("disabled",true);
              // $('#rohsYes').removeClass('active');
              // $('#rohsYes').removeClass('btn-green');
              // $('#rohsYes').addClass('btn-gray');
              // $('#rohsNo').removeClass('btn-gray');
              // $('#rohsNo').addClass('active');
              // $('#rohsNo').addClass('btn-green');
            }

            if(this.boardDetailList.layers - 1 > 6){
              $('#electricalTestingNo').prop("disabled",true);
              $('#testingToolTip').show();
              if($('#electricalTestingNo').hasClass('active')){
                $('#electricalTestingNo').removeClass('active');
                $('#electricalTestingNo').removeClass('btn-green');
                $('#electricalTestingNo').addClass('btn-gray');
                $('#electricalTestingYes').removeClass('btn-gray');
                $('#electricalTestingYes').removeClass('active');
                $('#electricalTestingYes').addClass('btn-green');
              }
            }else{
              $('#electricalTestingNo').prop("disabled",false);
              $('#testingToolTip').hide();
            }
            if(!this.commonService.commonMainObj.backToBoardDetails){
              if(this.boardDetailList.layers > 1){
                this.callPushToArray(this.layersImg,'Number of Layers',this.boardDetailList.layers - 1 + ' Layer');
              }
              this.callPushToArray(this.noOfHolesPerBoardsImg,'Number of Holes (per board)',this.boardDetailList.noOfHolesPerBoard);
              this.callPushToArray(this.boardDimensionImg,'Individual Board Dimensions (inches)',this.boardDetailList.dimensionX +' X '+ this.boardDetailList.dimensionY);
              this.callPushToArray(this.blindBuriedImg,'Blind / Buried vias',$('#blindBuriedBoardYes').hasClass('active')?"Yes":"No");
              this.callPushToArray(this.flexRigidBoardImg,'Flex / Rigid-Flex Board',$('#flexRigidBoardYes').hasClass('active')?"Yes":"No");
              this.callPushToArray(this.boardMaterialImg,'Board Material',this.boardDetailList.boardMaterial);
              this.callPushToArray(this.boardThicknessImg,'Board Thickness',this.boardDetailList.boardThickness);
              this.callPushToArray(this.minHoleSizeImg,'Minimum Hole Size',this.boardDetailList.minHoleSize);
              this.callPushToArray(this.surfaceFinishImg,'Surface Finish',this.boardDetailList.surfaceFinish);
              this.callPushToArray(this.minimumTraceImg,'Minimum Trace',this.boardDetailList.minimumTrace);
              this.callPushToArray(this.minimumSpaceImg,'Minimum Space',this.boardDetailList.minimumSpace);
              this.callPushToArray(this.maxFinishCopperWeightImg,'Maximum Finish Copper Weight', this.boardDetailList.maxFinishCopperWeight);
              this.callPushToArray(this.innerMinimumTraceImg,'Inner Minimum Trace',this.boardDetailList.innerMinimumTrace);
              this.callPushToArray(this.innerMinimumSpaceImg,'Inner Minimum Space',this.boardDetailList.innerMinimumSpace);
              this.callPushToArray(this.innerMaxFinishCopperWeightImg,'Inner Maximum Finish Copper Weight',this.boardDetailList.layers - 1 > 2 ? this.boardDetailList.innerMaxFinishCopperWeight:'Not Applicable');
              this.callPushToArray(this.solderMaskImg,'Solder Mask',$('#solderMaskYes').hasClass('active')?"Yes":"No");
              this.callPushToArray(this.solderMaskSidesImg,'Solder Mask Sides',$('#solderMaskYes').hasClass('active') ? this.boardDetailList.solderMaskSides : "");
              this.callPushToArray(this.solderMaskTypesImg,'Solder Mask Type',$('#solderMaskYes').hasClass('active') ? this.boardDetailList.solderMaskTypes : "");
              this.callPushToArray(this.solderMaskColorImg,'Solder Mask Color',$('#solderMaskYes').hasClass('active') ? this.boardDetailList.solderMaskColor : "");
              this.callPushToArray(this.solderMaskFinishImg,'Solder Mask Finish',$('#solderMaskYes').hasClass('active') ? this.boardDetailList.solderMaskFinish : "");
              this.callPushToArray(this.silkScreenImg,'Silk Screen',$('#silkScreenYes').hasClass('active')?"Yes":"No")
              this.callPushToArray(this.silkScreenSidesImg,'Silk Screen Sides',$('#silkScreenYes').hasClass('active') ? this.boardDetailList.silkScreenSides : "");
              this.callPushToArray(this.silkScreenColorImg,'Silk Screen Color', $('#silkScreenYes').hasClass('active') ? this.boardDetailList.silkScreenColor : "");
              this.callPushToArray(this.internalSlotsCutOutImg,'Internal Slots or Internal Cutouts',this.boardDetailList.internalSlotsCutOut);
              this.callPushToArray(this.controlledImpedanceImg,'Controlled impedance',this.boardDetailList.controlledImpedance);
              this.callPushToArray(this.routeAndRetainImg,'Route and Retain',$('#routeAndRetainYes').hasClass('active')?"Yes":"No");
              this.callPushToArray(this.scoringImg,'Scoring',$('#scoringYes').hasClass('active')?"Yes":"No");
              this.callPushToArray(this.goldFingersImg,'Gold Fingers',$('#goldFingersYes').hasClass('active')?"Yes":"No");
              this.callPushToArray(this.rohsImg,'Allow RoHS Marking',$('#rohsYes').hasClass('active')?"Yes":"No");
              this.callPushToArray(this.allowVendorMarkingImg,'Allow vendor markings on boards',$('#allowVendorMarkingsYes').hasClass('active')?"Yes":"No");
              this.callPushToArray(this.boardAsArrayImg,'Boards setup as an array',$('#boardAsArrayYes').hasClass('active')?"Yes":"No");
              this.callPushToArray(this.quantityOfIndividualBoardsImg ,'Quantity of Individual Boards',this.boardDetailList.boardQty1+','+this.boardDetailList.boardQty2+','+this.boardDetailList.boardQty3+','+this.boardDetailList.boardQty4);
              this.callPushToArray(this.counterSinkImg,'Counter Sink',$('#counterSinkYes').hasClass('active')?"Yes":"No");
            }

            if(this.commonService.commonMainObj.backToBoardDetails){
              this.boardDetailList.email = this.commonService.commonMainObj.boardDetailsDataObj.email;
              this.boardDetailList.noOfHolesPerBoard = this.commonService.commonMainObj.boardDetailsDataObj.noOfHolesPerBoard;
              this.boardDetailList.dimensionX = this.commonService.commonMainObj.boardDetailsDataObj.indBoardXDim;
              this.boardDetailList.dimensionY = this.commonService.commonMainObj.boardDetailsDataObj.indBoardYDim;
              this.boardDetailList.layers = parseInt(this.commonService.commonMainObj.boardDetailsDataObj.layers.split(' ')[0]) + 1;
              if(this.boardDetailList.layers - 1 > 2){
                this.hideInnerLayerContent=false;
              }else{
                this.hideInnerLayerContent=true;  
              }
              this.boardDetailList.innerMinimumTrace = this.commonService.commonMainObj.minInnerTraceSelected == 'Not Applicable'?this.boardDetailList.innerMinimumTrace:this.commonService.commonMainObj.minInnerTraceSelected;
              this.boardDetailList.innerMinimumSpace = this.commonService.commonMainObj.minInnerSpaceSelected == 'Not Applicable'?this.boardDetailList.innerMinimumSpace:this.commonService.commonMainObj.minInnerSpaceSelected;
              this.boardDetailList.innerMaxFinishCopperWeight = this.commonService.commonMainObj.boardDetailsDataObj.innerLyrFinishCopper == 'Not Applicable'?this.boardDetailList.innerMaxFinishCopperWeight:this.commonService.commonMainObj.boardDetailsDataObj.innerLyrFinishCopper;
              this.boardDetailList.boardMaterial = this.commonService.commonMainObj.boardDetailsDataObj.material;
              this.boardDetailList.boardThickness = this.commonService.commonMainObj.boardDetailsDataObj.finishedThickness;
              this.boardDetailList.minHoleSize = this.commonService.commonMainObj.minHoleSizeSelected;
              this.boardDetailList.surfaceFinish = this.commonService.commonMainObj.boardDetailsDataObj.surfaceFinish;
              this.boardDetailList.minimumTrace = this.commonService.commonMainObj.minTraceSelected;
              this.boardDetailList.minimumSpace = this.commonService.commonMainObj.minSpaceSelected;
              this.boardDetailList.maxFinishCopperWeight = this.commonService.commonMainObj.boardDetailsDataObj.outerLyrFinishCopper;
              
              if(this.commonService.commonMainObj.boardDetailsDataObj.solderMask == 'Yes'){
                this.boardDetailList.solderMaskSides = this.commonService.commonMainObj.boardDetailsDataObj.solderMaskSides;
                this.boardDetailList.solderMaskTypes = this.commonService.commonMainObj.boardDetailsDataObj.solderMaskType;
                this.boardDetailList.solderMaskColor = this.commonService.commonMainObj.boardDetailsDataObj.solderMaskColor;
                this.boardDetailList.solderMaskFinish = this.commonService.commonMainObj.boardDetailsDataObj.solderMaskFinish;
                this.solderMaskSelectedYes();
              }else{
                this.solderMaskSelectedNo();
              }
              if(this.commonService.commonMainObj.boardDetailsDataObj.silkScreen == 'Yes'){
                this.boardDetailList.silkScreenSides = this.commonService.commonMainObj.boardDetailsDataObj.silkScreenSides;
                this.boardDetailList.silkScreenColor = this.commonService.commonMainObj.boardDetailsDataObj.silkScreenColor;
                this.silkScreenIsSeclectedYes();
              }else{
                this.silkScreenIsSeclectedNo();
              }
              this.boardDetailList.internalSlotsCutOut = this.commonService.commonMainObj.boardDetailsDataObj.slotsCutouts;
              this.boardDetailList.controlledImpedance = this.commonService.commonMainObj.controlledImpedance;
              if(this.commonService.commonMainObj.boardDetailsDataObj.arrays == 'Yes'){
                this.boardAsArraySelectedYes();
                this.boardAsArraySelected = true;
                this.boardDetailList.boardsPerArray = this.commonService.commonMainObj.boardDetailsDataObj.boardsPerArray;
                this.boardDetailList.arrayDimensionX = this.commonService.commonMainObj.boardDetailsDataObj.arrayXDim;
                this.boardDetailList.arrayDimensionY = this.commonService.commonMainObj.boardDetailsDataObj.arrayYDim;
                this.arrayDefaultXDim = this.commonService.commonMainObj.boardDetailsDataObj.arrayXDim;
                this.arrayDefaultYDim = this.commonService.commonMainObj.boardDetailsDataObj.arrayYDim;
                if(this.boardDetailList.arrayDimensionX != null && this.boardDetailList.arrayDimensionX != '' && this.boardDetailList.arrayDimensionY != null && this.boardDetailList.arrayDimensionY != ''){
                  this.boardsPerArrayImg = "Extracted_icon";
                  $('#boardPerArrayDimensionHide').show();
                  this.boardPerArrayDimensionImg = "Extracted_icon";
                }else{
                  $('#boardPerArrayDimensionHide').hide();
                  this.boardsPerArrayImg = "Default_icon";
                }
              }else if(this.commonService.commonMainObj.boardDetailsDataObj.arrays == 'No'){
                this.boardAsArraySelectedNo();
                this.boardAsArraySelected = false;
              }
              if(this.commonService.commonMainObj.boardDetailsDataObj.routeAndRetain == 'Yes'){
                this.routeAndRetainSelectedYes();
              }else{
                this.routeAndRetainSelectedNo();  
              }
              if(this.commonService.commonMainObj.boardDetailsDataObj.routeAndRetain == 'Yes'){
                this.routeAndRetainSelectedYes();
              }else{
                this.routeAndRetainSelectedNo();  
              }
              $('#itarSwitchButtonGroup').show();
              $('#itarRadioButtonGroup').hide();
              if(this.commonService.commonMainObj.boardDetailsDataObj.itar == 'Yes'){
                $('#itarSitchYes').addClass('btn-green');
                $('#itarSitchYes').addClass('active');
                $('#itarSitchYes').removeClass('btn-gray');
                $('#itarSitchNo').removeClass('btn-green');
                $('#itarSitchNo').addClass('btn-gray');
                $('#itarSitchNo').removeClass('active');
                this.itarSitchImg = "Updated_icon"
              }else if(this.commonService.commonMainObj.boardDetailsDataObj.itar == 'No'){
                $('#itarSitchNo').addClass('btn-green');
                $('#itarSitchNo').addClass('active');
                $('#itarSitchNo').removeClass('btn-gray');
                $('#itarSitchYes').removeClass('btn-green');
                $('#itarSitchYes').removeClass('active');
                $('#itarSitchYes').addClass('btn-gray');
                this.itarSitchImg = "Updated_icon"
              }
              if(this.commonService.commonMainObj.boardDetailsDataObj.blindburiedvias == 'Yes'){
                this.blindBuriedSelectedYes();
              }else{
                this.blindBuriedSelectedNo();
              }
              if(this.commonService.commonMainObj.boardDetailsDataObj.rigidflexboard == 'No'){
                this.rigidFlexBoardNo();
              }else{
                this.rigidFlexBoardYes();
              }
              if(this.commonService.commonMainObj.boardDetailsDataObj.scoring == 'Yes'){
                this.scoringSelectedYes();
              }else{
                this.scoringSelectedNo();
              }
              if(this.commonService.commonMainObj.boardDetailsDataObj.goldFingers == 'Yes'){
                this.goldFingerSelectedYes();
              }else{
                this.goldFingerSelectedNo();
              }
              if(this.commonService.commonMainObj.boardDetailsDataObj.roHSMarking == 'Yes'){
                this.roHSMarkingSelectedYes();
              }else{
                this.roHSMarkingSelectedNo();
              }
              if(this.commonService.commonMainObj.boardDetailsDataObj.vendorMarking == 'Yes'){
                this.vendorMarkingSelectedYes();
              }else{
                this.vendorMarkingSelectedNo();
              }
              if(this.commonService.commonMainObj.boardDetailsDataObj.counterSink == 'Yes'){
                this.counterSinkSelectedYes();
              }else{
                this.counterSinkSelectedNo();
              }
            }

            if(this.commonService.commonMainObj.backToBoardDetails){
              for(var quoteInputGroup of this.productsData.products[0].quoteInputGroups) {
                for(var quoteInput of quoteInputGroup.quoteInputs) {
                  if(quoteInput.inputName == 'layers'){
                    if(quoteInput.default == this.boardDetailList.layers && quoteInput.isExtracted){
                      this.layersImg = "Extracted_icon";
                    }else if(quoteInput.default == this.boardDetailList.layers && !quoteInput.isExtracted){
                      this.layersImg = "Default_icon";
                    }else{
                      this.layersImg = "Updated_icon";
                    }
                  }
                }
              }

              for(var quoteInputGroup of this.productsData.products[0].quoteInputGroups) {
                for(var quoteInput of quoteInputGroup.quoteInputs) {
                  if(quoteInput.inputName == "material"){
                    for (var vm in quoteInput.valueMap) {
                      if(quoteInput.default == vm){
                        var defaultValue = quoteInput.valueMap[vm];
                        if(defaultValue == this.boardDetailList.boardMaterial && quoteInput.isExtracted){
                          this.boardMaterialImg = "Extracted_icon";
                        }else if(defaultValue == this.boardDetailList.boardMaterial && !quoteInput.isExtracted){
                          this.boardMaterialImg = "Default_icon";
                        }else{
                          this.boardMaterialImg = "Updated_icon";
                        }
                      }
                    }
                  }else if(quoteInput.inputName == "minHoleSize"){
                    for (var vm in quoteInput.valueMap) {
                      if(quoteInput.default == vm){
                        var defaultValue = quoteInput.valueMap[vm];
                        if(defaultValue == this.boardDetailList.minHoleSize && quoteInput.isExtracted){
                          this.minHoleSizeImg = "Extracted_icon";
                        }else if(defaultValue == this.boardDetailList.minHoleSize && !quoteInput.isExtracted){
                          this.minHoleSizeImg = "Default_icon";
                        }else{
                          this.minHoleSizeImg = "Updated_icon";
                        }
                      }
                    }
                  }else if(quoteInput.inputName == "surfaceFinish"){
                    for (var vm in quoteInput.valueMap) {
                      if(quoteInput.default == vm){
                        var defaultValue = quoteInput.valueMap[vm];
                        if(defaultValue == this.boardDetailList.surfaceFinish && quoteInput.isExtracted){
                          this.surfaceFinishImg = "Extracted_icon";
                        }else if(defaultValue == this.boardDetailList.surfaceFinish && !quoteInput.isExtracted){
                          this.surfaceFinishImg = "Default_icon";
                        }else{
                          this.surfaceFinishImg = "Updated_icon";
                        }
                      }
                    }
                  }else if(quoteInput.inputName == "finishedThickness"){
                    for (var vm in quoteInput.valueMap) {
                      if(quoteInput.default == vm){
                        var defaultValue = quoteInput.valueMap[vm];
                        if(defaultValue == this.boardDetailList.boardThickness && quoteInput.isExtracted){
                          this.boardThicknessImg = "Extracted_icon";
                        }else if(defaultValue == this.boardDetailList.boardThickness && !quoteInput.isExtracted){
                          this.boardThicknessImg = "Default_icon";
                        }else{
                          this.boardThicknessImg = "Updated_icon";
                        }
                      }
                    }
                  }else if(quoteInput.inputName == "minimumTrace"){
                    for (var vm in quoteInput.valueMap) {
                      if(quoteInput.default == vm){
                        var defaultValue = quoteInput.valueMap[vm];
                        if(defaultValue == this.boardDetailList.minimumTrace && quoteInput.isExtracted){
                          this.minimumTraceImg = "Extracted_icon";
                        }else if(defaultValue == this.boardDetailList.minimumTrace && !quoteInput.isExtracted){
                          this.minimumTraceImg = "Default_icon";
                        }else{
                          this.minimumTraceImg = "Updated_icon";
                        }
                      }
                    }
                  }else if(quoteInput.inputName == "outerLyrFinishCopper"){
                    for (var vm in quoteInput.valueMap) {
                      if(quoteInput.default == vm){
                        var defaultValue = quoteInput.valueMap[vm];
                        if(defaultValue == this.boardDetailList.maxFinishCopperWeight && quoteInput.isExtracted){
                          this.maxFinishCopperWeightImg = "Extracted_icon";
                        }else if(defaultValue == this.boardDetailList.maxFinishCopperWeight && !quoteInput.isExtracted){
                          this.maxFinishCopperWeightImg = "Default_icon";
                        }else{
                          this.maxFinishCopperWeightImg = "Updated_icon";
                        }
                      }
                    }
                  }else if(quoteInput.inputName == "minimumSpace"){
                    for (var vm in quoteInput.valueMap) {
                      if(quoteInput.default == vm){
                        var defaultValue = quoteInput.valueMap[vm];
                        if(defaultValue == this.boardDetailList.minimumSpace && quoteInput.isExtracted){
                          this.minimumSpaceImg = "Extracted_icon";
                        }else if(defaultValue == this.boardDetailList.minimumSpace && !quoteInput.isExtracted){
                          this.minimumSpaceImg = "Default_icon";
                        }else{
                          this.minimumSpaceImg = "Updated_icon";
                        }
                      }
                    }
                  }else if(quoteInput.inputName == "minimumTraceInnerLyr"){
                    //this.boardDetailList.innerMinimumTrace = currentElementValue;
                    for (var vm in quoteInput.valueMap) {
                      if(quoteInput.default == vm){
                        var defaultValue = quoteInput.valueMap[vm];
                        if(defaultValue == this.boardDetailList.innerMinimumTrace && quoteInput.isExtracted){
                          this.innerMinimumTraceImg = "Extracted_icon";
                        }else if(defaultValue == this.boardDetailList.innerMinimumTrace && !quoteInput.isExtracted){
                          this.innerMinimumTraceImg = "Default_icon";
                        }else{
                          this.innerMinimumTraceImg = "Updated_icon";
                        }
                      }
                    }
                  }else if(quoteInput.inputName == "innerLyrFinishCopper"){
                    for (var vm in quoteInput.valueMap) {
                      if(quoteInput.default == vm){
                        var defaultValue = quoteInput.valueMap[vm];
                        if(defaultValue == this.boardDetailList.innerMaxFinishCopperWeight && quoteInput.isExtracted){
                          this.innerMaxFinishCopperWeightImg = "Extracted_icon";
                        }else if(defaultValue == this.boardDetailList.innerMaxFinishCopperWeight && !quoteInput.isExtracted){
                          this.innerMaxFinishCopperWeightImg = "Default_icon";
                        }else{
                          this.innerMaxFinishCopperWeightImg = "Updated_icon";
                        }
                      }
                    }
                  }else if(quoteInput.inputName == "minimumSpaceInnerLyr"){
                    //this.boardDetailList.innerMinimumTrace = currentElementValue;
                    for (var vm in quoteInput.valueMap) {
                      if(quoteInput.default == vm){
                        var defaultValue = quoteInput.valueMap[vm];
                        if(defaultValue == this.boardDetailList.innerMinimumSpace && quoteInput.isExtracted){
                          this.innerMinimumSpaceImg = "Extracted_icon";
                        }else if(defaultValue == this.boardDetailList.innerMinimumSpace && !quoteInput.isExtracted){
                          this.innerMinimumSpaceImg = "Default_icon";
                        }else{
                          this.innerMinimumSpaceImg = "Updated_icon";
                        }
                      }
                    }
                  }else if(quoteInput.inputName == "solderMaskSides"){
                    for (var vm in quoteInput.valueMap) {
                      if(quoteInput.default == vm){
                        var defaultValue = quoteInput.valueMap[vm];
                        if(defaultValue == this.boardDetailList.solderMaskSides && quoteInput.isExtracted){
                          this.solderMaskSidesImg = "Extracted_icon";
                        }else if(defaultValue == this.boardDetailList.solderMaskSides && !quoteInput.isExtracted){
                          this.solderMaskSidesImg = "Default_icon";
                        }else{
                          this.solderMaskSidesImg = "Updated_icon";
                        }
                      }
                    }
                  }else if(quoteInput.inputName == "solderMaskColor"){
                    for (var vm in quoteInput.valueMap) {
                      if(quoteInput.default == vm){
                        var defaultValue = quoteInput.valueMap[vm];
                        if(defaultValue == this.boardDetailList.solderMaskColor && quoteInput.isExtracted){
                          this.solderMaskColorImg = "Extracted_icon";
                        }else if(defaultValue == this.boardDetailList.solderMaskColor && !quoteInput.isExtracted){
                          this.solderMaskColorImg = "Default_icon";
                        }else{
                          this.solderMaskColorImg = "Updated_icon";
                        }
                      }else if(quoteInput.default == null){
                        if(this.boardDetailList.solderMaskColor == 'Green' && quoteInput.isExtracted){
                          this.solderMaskColorImg = "Extracted_icon";
                        }else if(this.boardDetailList.solderMaskColor == 'Green' && !quoteInput.isExtracted){
                          this.solderMaskColorImg = "Default_icon";
                        }else{
                          this.solderMaskColorImg = "Updated_icon";
                        }
                      }
                    }
                  }else if(quoteInput.inputName == "solderMaskType"){
                    for (var vm in quoteInput.valueMap) {
                      if(quoteInput.default == vm){
                        var defaultValue = quoteInput.valueMap[vm];
                        if(defaultValue == this.boardDetailList.solderMaskTypes && quoteInput.isExtracted){
                          this.solderMaskTypesImg = "Extracted_icon";
                        }else if(defaultValue == this.boardDetailList.solderMaskTypes && !quoteInput.isExtracted){
                          this.solderMaskTypesImg = "Default_icon";
                        }else{
                          this.solderMaskTypesImg = "Updated_icon";
                        }
                      }
                    }
                  }else if(quoteInput.inputName == "solderMaskFinish"){
                    for (var vm in quoteInput.valueMap) {
                      if(quoteInput.default == vm){
                        var defaultValue = quoteInput.valueMap[vm];
                        if(defaultValue == this.boardDetailList.solderMaskFinish && quoteInput.isExtracted){
                          this.solderMaskFinishImg = "Extracted_icon";
                        }else if(defaultValue == this.boardDetailList.solderMaskFinish && !quoteInput.isExtracted){
                          this.solderMaskFinishImg = "Default_icon";
                        }else{
                          this.solderMaskFinishImg = "Updated_icon";
                        }
                      }
                    }
                  }else if(quoteInput.inputName == "silkScreenSides"){
                    for (var vm in quoteInput.valueMap) {
                      if(quoteInput.default == vm){
                        var defaultValue = quoteInput.valueMap[vm];
                        if(defaultValue == this.boardDetailList.silkScreenSides && quoteInput.isExtracted){
                          this.silkScreenSidesImg = "Extracted_icon";
                        }else if(defaultValue == this.boardDetailList.silkScreenSides && !quoteInput.isExtracted){
                          this.silkScreenSidesImg = "Default_icon";
                        }else{
                          this.silkScreenSidesImg = "Updated_icon";
                        }
                      }else if(quoteInput.default == null){
                        if(this.boardDetailList.silkScreenSides == 'Both' && quoteInput.isExtracted){
                          this.silkScreenSidesImg = "Extracted_icon";
                        }else if(this.boardDetailList.silkScreenSides == 'Both' && !quoteInput.isExtracted){
                          this.silkScreenSidesImg = "Default_icon";
                        }else{
                          this.silkScreenSidesImg = "Updated_icon";
                        }
                      }
                    }
                  }else if(quoteInput.inputName == "silkScreenColor"){
                    for (var vm in quoteInput.valueMap) {
                      if(quoteInput.default == vm){
                        var defaultValue = quoteInput.valueMap[vm];
                        if(defaultValue == this.boardDetailList.silkScreenColor && quoteInput.isExtracted){
                          this.silkScreenColorImg = "Extracted_icon";
                        }else if(defaultValue == this.boardDetailList.silkScreenColor && !quoteInput.isExtracted){
                          this.silkScreenColorImg = "Default_icon";
                        }else{
                          this.silkScreenColorImg = "Updated_icon";
                        }
                      }else if(quoteInput.default == null){
                        if(this.boardDetailList.silkScreenColor == 'White' && quoteInput.isExtracted){
                          this.silkScreenColorImg = "Extracted_icon";
                        }else if(this.boardDetailList.silkScreenColor == 'White' && !quoteInput.isExtracted){
                          this.silkScreenColorImg = "Default_icon";
                        }else{
                          this.silkScreenColorImg = "Updated_icon";
                        }
                      }
                    }
                  }else if(quoteInput.inputName == "controlledImpedance"){
                    for (var vm in quoteInput.valueMap) {
                      if(quoteInput.default == vm){
                        var defaultValue = quoteInput.valueMap[vm];
                        if(defaultValue == this.boardDetailList.controlledImpedance && quoteInput.isExtracted){
                          this.controlledImpedanceImg = "Extracted_icon";
                        }else if(defaultValue == this.boardDetailList.controlledImpedance && !quoteInput.isExtracted){
                          this.controlledImpedanceImg = "Default_icon";
                        }else{
                          this.controlledImpedanceImg = "Updated_icon";
                        }
                      }
                    }
                  }else if(quoteInput.inputName == "slotsCutouts"){
                    for (var vm in quoteInput.valueMap) {
                      if(quoteInput.default == vm){
                        var defaultValue = quoteInput.valueMap[vm];
                        if(defaultValue == this.boardDetailList.internalSlotsCutOut && quoteInput.isExtracted){
                          this.internalSlotsCutOutImg = "Extracted_icon";
                        }else if(defaultValue == this.boardDetailList.internalSlotsCutOut && !quoteInput.isExtracted){
                          this.internalSlotsCutOutImg = "Default_icon";
                        }else{
                          this.internalSlotsCutOutImg = "Updated_icon";
                        }
                      }
                    }
                  }
                  //Select input change check completed here
                  //Text Inputs start change check start from Here
                  if(quoteInput.inputName == 'indBoardXDim'){
                    if(quoteInput.default == this.boardDetailList.dimensionX && this.boardDetailList.dimensionY == this.indBoardDefaultYDim && quoteInput.isExtracted){
                      this.boardDimensionImg = "Extracted_icon";
                    }else if(quoteInput.default == this.boardDetailList.dimensionX && this.boardDetailList.dimensionY == this.indBoardDefaultYDim && !quoteInput.isExtracted){
                      this.boardDimensionImg = "Default_icon";
                    }else{
                      this.boardDimensionImg = "Updated_icon";
                    }
                    $('#IndividualDimensionLableHide').show();
                  }else if(quoteInput.inputName == 'indBoardYDim'){
                    if(quoteInput.default == this.boardDetailList.dimensionY && this.boardDetailList.dimensionX == this.indBoardDefaultXDim && quoteInput.isExtracted){
                      this.boardDimensionImg = "Extracted_icon";
                    }else if(quoteInput.default == this.boardDetailList.dimensionY && this.boardDetailList.dimensionX == this.indBoardDefaultXDim && !quoteInput.isExtracted){
                      this.boardDimensionImg = "Default_icon";
                    }else{
                      this.boardDimensionImg = "Updated_icon";
                    }
                    $('#IndividualDimensionLableHide').show();
                  }else if(quoteInput.inputName == 'arrayXDim'){
                    if(quoteInput.default == this.boardDetailList.arrayDimensionX && this.boardDetailList.arrayDimensionY == this.arrayDefaultYDim && quoteInput.isExtracted){
                      this.boardPerArrayDimensionImg = "Extracted_icon";
                    }else if(quoteInput.default == this.boardDetailList.arrayDimensionX && this.boardDetailList.arrayDimensionY == this.arrayDefaultYDim && !quoteInput.isExtracted){
                      this.boardPerArrayDimensionImg = "Default_icon";
                    }else{
                      this.boardPerArrayDimensionImg = "Updated_icon";
                    }
                    setTimeout(() => {
                      if(this.boardDetailList.arrayDimensionX != '' && this.boardDetailList.arrayDimensionY != ''){
                        $('#boardPerArrayDimensionHide').show();
                      }else{
                        $('#boardPerArrayDimensionHide').hide();
                      }
                    }, 1000);
                    
                  }else if(quoteInput.inputName == 'arrayYDim'){
                    if(quoteInput.default == this.boardDetailList.arrayDimensionY && this.boardDetailList.arrayDimensionX == this.arrayDefaultXDim && quoteInput.isExtracted){
                      this.boardPerArrayDimensionImg = "Extracted_icon";
                    }else if(quoteInput.default == this.boardDetailList.arrayDimensionY && this.boardDetailList.arrayDimensionX == this.arrayDefaultXDim && !quoteInput.isExtracted){
                      this.boardPerArrayDimensionImg = "Default_icon";
                    }else{
                      this.boardPerArrayDimensionImg = "Updated_icon";
                    }
          
                    setTimeout(() => {
                      if(this.boardDetailList.arrayDimensionX != '' && this.boardDetailList.arrayDimensionY != ''){
                        $('#boardPerArrayDimensionHide').show();
                      }else{
                        $('#boardPerArrayDimensionHide').hide();
                      }
                    }, 1000);
                  }else if(quoteInput.inputName == 'boardsPerArray'){
                    if(quoteInput.default == this.boardDetailList.boardsPerArray && quoteInput.isExtracted){
                      this.boardsPerArrayImg = "Extracted_icon";
                    }else if(quoteInput.default == this.boardDetailList.boardsPerArray && !quoteInput.isExtracted){
                      this.boardsPerArrayImg = "Default_icon";
                    }else{
                      this.boardsPerArrayImg = "Updated_icon";
                    }
                    setTimeout(() => {
                      if(this.boardDetailList.boardsPerArray == null || this.boardDetailList.boardsPerArray == ''){
                        $('#boardPerArrayHide').css('display','none');
                      }else{
                        $('#boardPerArrayHide').css('display','block');
                      }
                    }, 1000);
                    
                  }else if(quoteInput.inputName == 'noOfHolesPerBoard'){
                    if(quoteInput.default == this.boardDetailList.noOfHolesPerBoard && quoteInput.isExtracted){
                      this.noOfHolesPerBoardsImg = "Extracted_icon";
                    }else if(quoteInput.default == this.boardDetailList.noOfHolesPerBoard && !quoteInput.isExtracted){
                      this.noOfHolesPerBoardsImg = "Default_icon";
                    }else{
                      this.noOfHolesPerBoardsImg = "Updated_icon";
                    }
          
                    if(this.boardDetailList.noOfHolesPerBoard != null && this.boardDetailList.noOfHolesPerBoard != ''){
                      $('#numberOfHolesTotipHide').show();
                    }else{
                      $('#numberOfHolesTotipHide').hide();
                    }
                  }else if(quoteInput.inputName == 'boardQty1'){
                    if(quoteInput.default == this.boardDetailList.boardQty1 && this.boardDetailList.boardQty2 == this.boardDefaultQty2 && this.boardDetailList.boardQty3 == this.boardDefaultQty3 && this.boardDetailList.boardQty4 == this.boardDefaultQty4 && quoteInput.isExtracted){
                      this.quantityOfIndividualBoardsImg = "Extracted_icon";
                    }else if(this.boardDefaultQty1 == this.boardDetailList.boardQty1 && this.boardDetailList.boardQty2 == this.boardDefaultQty2  && this.boardDetailList.boardQty3 == this.boardDefaultQty3  && this.boardDetailList.boardQty4 == this.boardDefaultQty4 && !quoteInput.isExtracted){
                      this.quantityOfIndividualBoardsImg = "Default_icon";
                    }else{
                      this.quantityOfIndividualBoardsImg = "Updated_icon";
                    }

                    if(quoteInput.default == null && this.boardDetailList.boardQty1 == '5' && this.boardDetailList.boardQty2 == '10' && this.boardDetailList.boardQty3 == '15' && this.boardDetailList.boardQty4 == '20' && quoteInput.isExtracted){
                      this.quantityOfIndividualBoardsImg = "Extracted_icon";
                    }else if(quoteInput.default == null && this.boardDetailList.boardQty1 == '5' && this.boardDetailList.boardQty2 == '10' && this.boardDetailList.boardQty3 == '15' && this.boardDetailList.boardQty2 == '20' && !quoteInput.isExtracted){
                      this.quantityOfIndividualBoardsImg = "Default_icon";
                    }else{
                      this.quantityOfIndividualBoardsImg = "Updated_icon";
                    }
          
                    // if(this.boardDetailList.boardQty1 != '' && this.boardDetailList.boardQty2 != ''){
                    //   $('#quantityOfIndividualBoardsImgHide').show();
                    // }else{
                    //   $('#quantityOfIndividualBoardsImgHide').hide();
                    // }
                  }else if(quoteInput.inputName == 'boardQty2'){
                    if(quoteInput.default == this.boardDetailList.boardQty2 && this.boardDetailList.boardQty1 == this.boardDefaultQty1 && this.boardDetailList.boardQty3 == this.boardDefaultQty3 && this.boardDetailList.boardQty4 == this.boardDefaultQty4 && quoteInput.isExtracted){
                      this.quantityOfIndividualBoardsImg = "Extracted_icon";
                    }else if(quoteInput.default == this.boardDetailList.boardQty2 && this.boardDetailList.boardQty1 == this.boardDefaultQty1 && this.boardDetailList.boardQty3 == this.boardDefaultQty3 && this.boardDetailList.boardQty4 == this.boardDefaultQty4 && !quoteInput.isExtracted){
                      this.quantityOfIndividualBoardsImg = "Default_icon";
                    }else{
                      this.quantityOfIndividualBoardsImg = "Updated_icon";
                    }

                    if(quoteInput.default == null && this.boardDefaultQty2 == '10' && this.boardDetailList.boardQty1 == '5' && this.boardDetailList.boardQty3 == '15' && this.boardDetailList.boardQty4 == '20' && quoteInput.isExtracted){
                      this.quantityOfIndividualBoardsImg = "Extracted_icon";
                    }else if(quoteInput.default == null && this.boardDefaultQty2 == '10' && this.boardDetailList.boardQty1 == '5' && this.boardDetailList.boardQty3 == '15' && this.boardDetailList.boardQty4 == '20' && !quoteInput.isExtracted){
                      this.quantityOfIndividualBoardsImg = "Default_icon";
                    }else{
                      this.quantityOfIndividualBoardsImg = "Updated_icon";
                    }
          
                    // if(this.boardDetailList.boardQty1 != '' && this.boardDetailList.boardQty2 != ''){
                    //   $('#quantityOfIndividualBoardsImgHide').show();
                    // }else{
                    //   $('#quantityOfIndividualBoardsImgHide').hide();
                    // }
                  }else if(quoteInput.inputName == 'boardQty3'){
                    if(quoteInput.default == this.boardDetailList.boardQty3 && this.boardDetailList.boardQty1 == this.boardDefaultQty1 && this.boardDetailList.boardQty2 == this.boardDefaultQty2 && this.boardDetailList.boardQty4 == this.boardDefaultQty4 && quoteInput.isExtracted){
                      this.quantityOfIndividualBoardsImg = "Extracted_icon";
                    }else if(quoteInput.default == this.boardDetailList.boardQty3 && this.boardDetailList.boardQty1 == this.boardDefaultQty1 && this.boardDetailList.boardQty2 == this.boardDefaultQty2 && this.boardDetailList.boardQty4 == this.boardDefaultQty4 && !quoteInput.isExtracted){
                      this.quantityOfIndividualBoardsImg = "Default_icon";
                    }else{
                      this.quantityOfIndividualBoardsImg = "Updated_icon";
                    }

                    if(quoteInput.default == null && this.boardDefaultQty3 == '15' && this.boardDetailList.boardQty1 == '5' && this.boardDetailList.boardQty2 == '10' && this.boardDetailList.boardQty4 == '20' && quoteInput.isExtracted){
                      this.quantityOfIndividualBoardsImg = "Extracted_icon";
                    }else if(quoteInput.default == null && this.boardDefaultQty3 == '15' && this.boardDetailList.boardQty1 == '5' && this.boardDetailList.boardQty2 == '10' && this.boardDetailList.boardQty4 == '20' && !quoteInput.isExtracted){
                      this.quantityOfIndividualBoardsImg = "Default_icon";
                    }else{
                      this.quantityOfIndividualBoardsImg = "Updated_icon";
                    }
                  }else if(quoteInput.inputName == 'boardQty4'){
                    if(quoteInput.default == this.boardDetailList.boardQty4 && this.boardDetailList.boardQty1 == this.boardDefaultQty1 && this.boardDetailList.boardQty2 == this.boardDefaultQty2 && this.boardDetailList.boardQty3 == this.boardDefaultQty3 && quoteInput.isExtracted){
                      this.quantityOfIndividualBoardsImg = "Extracted_icon";
                    }else if(quoteInput.default == this.boardDetailList.boardQty4 && this.boardDetailList.boardQty1 == this.boardDefaultQty1 && this.boardDetailList.boardQty2 == this.boardDefaultQty2 && this.boardDetailList.boardQty3 == this.boardDefaultQty3 && !quoteInput.isExtracted){
                      this.quantityOfIndividualBoardsImg = "Default_icon";
                    }else{
                      this.quantityOfIndividualBoardsImg = "Updated_icon";
                    }

                    if(quoteInput.default == null && this.boardDefaultQty4 == '20' && this.boardDetailList.boardQty1 == '5' && this.boardDetailList.boardQty2 == '10' && this.boardDetailList.boardQty3 == '15' && quoteInput.isExtracted){
                      this.quantityOfIndividualBoardsImg = "Extracted_icon";
                    }else if(quoteInput.default == null && this.boardDefaultQty4 == '20' && this.boardDetailList.boardQty1 == '5' && this.boardDetailList.boardQty2 == '10' && this.boardDetailList.boardQty3 == '15' && !quoteInput.isExtracted){
                      this.quantityOfIndividualBoardsImg = "Default_icon";
                    }else{
                      this.quantityOfIndividualBoardsImg = "Updated_icon";
                    }
                  }

                  //Switch buttons images check
                  if(quoteInput.inputName == "arrays"){

                    if((quoteInput.default == '0' && $('#boardAsArrayNo').hasClass('active')) || (quoteInput.default == '1' && $('#boardAsArrayYes').hasClass('active'))){
                      if(quoteInput.isExtracted){
                        this.boardAsArrayImg = "Extracted_icon";
                      }else if(!quoteInput.isExtracted){
                        this.boardAsArrayImg = "Default_icon";
                      }
                    }else{
                      this.boardAsArrayImg = "Updated_icon";
                    }
                  }else if(quoteInput.inputName == "flexRigidFlex"){
                    if((quoteInput.default == '0' && $('#flexRigidBoardNo').hasClass('active')) || (quoteInput.default == '1' && $('#flexRigidBoardYes').hasClass('active'))){
                      if(quoteInput.isExtracted){
                        this.flexRigidBoardImg = "Extracted_icon";
                      }else if(!quoteInput.isExtracted){
                        this.flexRigidBoardImg = "Default_icon";
                      }
                    }else{
                      this.flexRigidBoardImg = "Updated_icon";
                    }
                  }else if(quoteInput.inputName == "blindburiedvias"){
                    if((quoteInput.default == '0' && $('#blindBuriedBoardNo').hasClass('active')) || (quoteInput.default == '1' && $('#blindBuriedBoardYes').hasClass('active'))){
                      if(quoteInput.isExtracted){
                        this.blindBuriedImg = "Extracted_icon";
                      }else if(!quoteInput.isExtracted){
                        this.blindBuriedImg = "Default_icon";
                      }
                    }else{
                      this.blindBuriedImg = "Updated_icon";
                    }
                  }else if(quoteInput.inputName == "routeAndRetain"){
                    if((quoteInput.default == '0' && $('#routeAndRetainNo').hasClass('active')) || (quoteInput.default == '1' && $('#routeAndRetainYes').hasClass('active'))){
                      if(quoteInput.isExtracted){
                        this.routeAndRetainImg = "Extracted_icon";
                      }else if(!quoteInput.isExtracted){
                        this.routeAndRetainImg = "Default_icon";
                      }
                    }else{
                      this.routeAndRetainImg = "Updated_icon";
                    }
                  }else if(quoteInput.inputName == "scoring"){
                    if((quoteInput.default == '0' && $('#scoringNo').hasClass('active')) || (quoteInput.default == '1' && $('#scoringYes').hasClass('active'))){
                      if(quoteInput.isExtracted){
                        this.scoringImg = "Extracted_icon";
                      }else if(!quoteInput.isExtracted){
                        this.scoringImg = "Default_icon";
                      }
                    }else{
                      this.scoringImg = "Updated_icon";
                    }
                  }else if(quoteInput.inputName == "goldFingers"){
                    if((quoteInput.default == '0' && $('#goldFingersNo').hasClass('active')) || (quoteInput.default == '1' && $('#goldFingersYes').hasClass('active'))){
                      if(quoteInput.isExtracted){
                        this.goldFingersImg = "Extracted_icon";
                      }else if(!quoteInput.isExtracted){
                        this.goldFingersImg = "Default_icon";
                      }
                    }else{
                      this.goldFingersImg = "Updated_icon";
                    }
                  }else if(quoteInput.inputName == "vendorMarking"){
                    if((quoteInput.default == '0' && $('#allowVendorMarkingsNo').hasClass('active')) || (quoteInput.default == '1' && $('#allowVendorMarkingsYes').hasClass('active'))){
                      if(quoteInput.isExtracted){
                        this.allowVendorMarkingImg = "Extracted_icon";
                      }else if(!quoteInput.isExtracted){
                        this.allowVendorMarkingImg = "Default_icon";
                      }
                    }else{
                      this.allowVendorMarkingImg = "Updated_icon";
                    }
                  }else if(quoteInput.inputName == "solderMask"){
                    if((quoteInput.default == '0' && $('#solderMaskNo').hasClass('active')) || (quoteInput.default == '1' && $('#solderMaskYes').hasClass('active'))){
                      if(quoteInput.isExtracted){
                        this.solderMaskImg = "Extracted_icon";
                      }else if(!quoteInput.isExtracted){
                        this.solderMaskImg = "Default_icon";
                      }
                    }else{
                      this.solderMaskImg = "Updated_icon";
                    }
                  }else if(quoteInput.inputName == "silkScreen"){
                    if((quoteInput.default == '0' && $('#silkScreenNo').hasClass('active')) || (quoteInput.default == '1' && $('#silkScreenYes').hasClass('active'))){
                      if(quoteInput.isExtracted){
                        this.silkScreenImg = "Extracted_icon";
                      }else if(!quoteInput.isExtracted){
                        this.silkScreenImg = "Default_icon";
                      }
                    }else{
                      this.silkScreenImg = "Updated_icon";
                    }
                  }else if(quoteInput.inputName == "roHSMarking"){
                    if((quoteInput.default == '0' && $('#rohsNo').hasClass('active')) || (quoteInput.default == '1' && $('#rohsYes').hasClass('active'))){
                      if(quoteInput.isExtracted){
                        this.rohsImg = "Extracted_icon";
                      }else if(!quoteInput.isExtracted){
                        this.rohsImg = "Default_icon";
                      }
                    }else{
                      this.rohsImg = "Updated_icon";
                    }
                  }else if(quoteInput.inputName == "counterSink"){
                    if((quoteInput.default == '0' && $('#counterSinkNo').hasClass('active')) || (quoteInput.default == '1' && $('#counterSinkYes').hasClass('active'))){
                      if(quoteInput.isExtracted){
                        this.counterSinkImg = "Extracted_icon";
                      }else if(!quoteInput.isExtracted){
                        this.counterSinkImg = "Default_icon";
                      }
                    }else{
                      this.counterSinkImg = "Updated_icon";
                    }
                  }
                }
              }
            }
            if(this.commonService.commonMainObj.backToBoardDetails){
              this.callPushToArray(this.layersImg,'Number of Layers',this.boardDetailList.layers - 1 + ' Layer');
              this.callPushToArray(this.noOfHolesPerBoardsImg,'Number of Holes (per board)',this.boardDetailList.noOfHolesPerBoard);
              this.callPushToArray(this.boardDimensionImg,'Individual Board Dimensions (inches)',this.boardDetailList.dimensionX  +' X '+ this.boardDetailList.dimensionY);
              this.callPushToArray(this.blindBuriedImg,'Blind / Buried vias',$('#blindBuriedBoardYes').hasClass('active')?"Yes":"No");
              this.callPushToArray(this.flexRigidBoardImg,'Flex / Rigid-Flex Board',$('#flexRigidBoardYes').hasClass('active')?"Yes":"No");
              this.callPushToArray(this.boardMaterialImg,'Board Material',this.boardDetailList.boardMaterial);
              this.callPushToArray(this.boardThicknessImg,'Board Thickness',this.boardDetailList.boardThickness);
              this.callPushToArray(this.minHoleSizeImg,'Minimum Hole Size',this.boardDetailList.minHoleSize);
              this.callPushToArray(this.surfaceFinishImg,'Surface Finish',this.boardDetailList.surfaceFinish);
              this.callPushToArray(this.minimumTraceImg,'Minimum Trace',this.boardDetailList.minimumTrace);
              this.callPushToArray(this.minimumSpaceImg,'Minimum Space',this.boardDetailList.minimumSpace);
              this.callPushToArray(this.maxFinishCopperWeightImg,'Maximum Finish Copper Weight', this.boardDetailList.maxFinishCopperWeight);
              this.callPushToArray(this.innerMinimumTraceImg,'Inner Minimum Trace',this.boardDetailList.innerMinimumTrace);
              this.callPushToArray(this.innerMinimumSpaceImg,'Inner Minimum Space',this.boardDetailList.innerMinimumSpace);
              this.callPushToArray(this.innerMaxFinishCopperWeightImg,'Inner Maximum Finish Copper Weight',this.boardDetailList.layers - 1 > 2 ? this.boardDetailList.innerMaxFinishCopperWeight:'Not Applicable');
              this.callPushToArray(this.solderMaskImg,'Solder Mask',$('#solderMaskYes').hasClass('active')?"Yes":"No");
              this.callPushToArray(this.solderMaskSidesImg,'Solder Mask Sides',$('#solderMaskYes').hasClass('active') ? this.boardDetailList.solderMaskSides : "");
              this.callPushToArray(this.solderMaskTypesImg,'Solder Mask Type',$('#solderMaskYes').hasClass('active') ? this.boardDetailList.solderMaskTypes : "");
              this.callPushToArray(this.solderMaskColorImg,'Solder Mask Color',$('#solderMaskYes').hasClass('active') ? this.boardDetailList.solderMaskColor : "");
              this.callPushToArray(this.solderMaskFinishImg,'Solder Mask Finish',$('#solderMaskYes').hasClass('active') ? this.boardDetailList.solderMaskFinish : "");
              this.callPushToArray(this.silkScreenImg,'Silk Screen',$('#silkScreenYes').hasClass('active')?"Yes":"No")
              this.callPushToArray(this.silkScreenSidesImg,'Silk Screen Sides',$('#silkScreenYes').hasClass('active') ? this.boardDetailList.silkScreenSides : "");
              this.callPushToArray(this.silkScreenColorImg,'Silk Screen Color', $('#silkScreenYes').hasClass('active') ? this.boardDetailList.silkScreenColor : "");
              this.callPushToArray(this.internalSlotsCutOutImg,'Internal Slots or Internal Cutouts',this.boardDetailList.internalSlotsCutOut);
              this.callPushToArray(this.controlledImpedanceImg,'Controlled impedance',this.boardDetailList.controlledImpedance);
              this.callPushToArray(this.routeAndRetainImg,'Route and Retain',$('#routeAndRetainYes').hasClass('active')?"Yes":"No");
              this.callPushToArray(this.scoringImg,'Scoring',$('#scoringYes').hasClass('active')?"Yes":"No");
              this.callPushToArray(this.goldFingersImg,'Gold Fingers',$('#goldFingersYes').hasClass('active')?"Yes":"No");
              this.callPushToArray(this.rohsImg,'Allow RoHS Marking',$('#rohsYes').hasClass('active')?"Yes":"No");
              this.callPushToArray(this.allowVendorMarkingImg,'Allow vendor markings on boards',$('#allowVendorMarkingsYes').hasClass('active')?"Yes":"No");
              this.callPushToArray(this.boardAsArrayImg,'Boards setup as an array',this.boardDetailList.boardsPerArray);
              this.callPushToArray(this.quantityOfIndividualBoardsImg ,'Quantity of Individual Boards',this.boardDetailList.boardQty1+','+this.boardDetailList.boardQty2);
              this.callPushToArray(this.itarSitchImg,'Need ITAR Compliance?',$('#itarSitchYes').hasClass('active')?"Yes":"No");
              this.callPushToArray(this.counterSinkImg,'Counter Sink',$('#counterSinkYes').hasClass('active')?"Yes":"No");
              if(this.boardAsArraySelected){
                this.callPushToArray(this.boardsPerArrayImg ,'Boards per array',this.boardDetailList.boardsPerArray);
                this.callPushToArray(this.boardPerArrayDimensionImg ,'Array Dimensions (inches)',this.boardDetailList.arrayDimensionX + ' X ' +this.boardDetailList.arrayDimensionY);
              }
            }
          if(this.commonService.commonMainObj.backToBoardDetails && this.commonService.commonMainObj.userSessionMemberId != null){
            this.commonService.sessionPortalLoad();
            this.apiService.checkUserSessionApi().subscribe((data: any)=>{
            },error =>{
              console.log('Error in checking user session', error);     
            })
          }
        }
    },error => {
      this.commonService.loadingHide();
        console.log("Error in creating part data",error);
    });
    
    if(this.commonService.commonMainObj.fileUploadedData.botImage){
      this.apiService.getImageFile(this.commonService.commonMainObj.fileUploadedData.botImage,"bottom");
    }
    setTimeout(()=>{
      if(this.commonService.commonMainObj.fileUploadedData.topImage){
      this.apiService.getImageFile(this.commonService.commonMainObj.fileUploadedData.topImage,"top");
    }
  },500)
  }
  
  ngOnDestroy() {
    this.commonService.destroyRefreshEvent();
  }

  callPushToArray(icon: any, param: any, val:any){
    var paramObj={
      "key":param,
      "value":val
    }
    if(val != undefined && val != '' ){
      if(icon == "Extracted_icon"){
        this.extractedPcbSpecification.push(paramObj);
      }else if(icon == "Default_icon"){
        this.defaultPcbSpecification.push(paramObj);
      }else if(icon == "Updated_icon"){
        this.updatedPcbSpecification.push(paramObj);
      }
    }
  }
   routeAndRetainSelectedYes(){
    $('#routeAndRetainNo').removeClass('active');
    $('#routeAndRetainNo').removeClass('btn-green');
    $('#routeAndRetainNo').addClass('btn-gray');
    $('#routeAndRetainYes').removeClass('btn-gray');
    $('#routeAndRetainYes').addClass('active');
    $('#routeAndRetainYes').addClass('btn-green');
  }
  routeAndRetainSelectedNo(){
    $('#routeAndRetainYes').removeClass('active');
    $('#routeAndRetainYes').removeClass('btn-green');
    $('#routeAndRetainYes').addClass('btn-gray');
    $('#routeAndRetainNo').removeClass('btn-gray');
    $('#routeAndRetainNo').addClass('active');
    $('#routeAndRetainNo').addClass('btn-green');
  }
  boardAsArraySelectedYes(){
    $('#boardAsArrayNo').removeClass('active');
    $('#boardAsArrayNo').removeClass('btn-green');
    $('#boardAsArrayNo').addClass('btn-gray');
    $('#boardAsArrayYes').removeClass('btn-gray');
    $('#boardAsArrayYes').addClass('active');
    $('#boardAsArrayYes').addClass('btn-green');
  }
  boardAsArraySelectedNo(){
    $('#boardAsArrayYes').removeClass('active');
    $('#boardAsArrayYes').removeClass('btn-green');
    $('#boardAsArrayYes').addClass('btn-gray');
    $('#boardAsArrayNo').removeClass('btn-gray');
    $('#boardAsArrayNo').addClass('active');
    $('#boardAsArrayNo').addClass('btn-green');
  }
  solderMaskSelectedYes(){
    $('#solderMaskNo').removeClass('active');
    $('#solderMaskNo').removeClass('btn-green');
    $('#solderMaskNo').addClass('btn-gray');
    $('#solderMaskYes').removeClass('btn-gray');
    $('#solderMaskYes').addClass('active');
    $('#solderMaskYes').addClass('btn-green');
    $('#fabSolderMaskSection').show();
  }
  solderMaskSelectedNo(){
    $('#solderMaskYes').removeClass('active');
    $('#solderMaskYes').removeClass('btn-green');
    $('#solderMaskYes').addClass('btn-gray');
    $('#solderMaskNo').removeClass('btn-gray');
    $('#solderMaskNo').addClass('active');
    $('#solderMaskNo').addClass('btn-green');
    $('#fabSolderMaskSection').hide();
  }
  blindBuriedSelectedNo(){
    $('#blindBuriedBoardYes').removeClass('active');
    $('#blindBuriedBoardYes').removeClass('btn-green');
    $('#blindBuriedBoardYes').addClass('btn-gray');
    $('#blindBuriedBoardNo').removeClass('btn-gray');
    $('#blindBuriedBoardNo').addClass('active');
    $('#blindBuriedBoardNo').addClass('btn-green');
  }
  blindBuriedSelectedYes(){
    $('#blindBuriedBoardNo').removeClass('active');
    $('#blindBuriedBoardNo').removeClass('btn-green');
    $('#blindBuriedBoardNo').addClass('btn-gray');
    $('#blindBuriedBoardYes').removeClass('btn-gray');
    $('#blindBuriedBoardYes').addClass('active');
    $('#blindBuriedBoardYes').addClass('btn-green');
  }
  rigidFlexBoardNo(){
    $('#flexRigidBoardNo').addClass('btn-green');
    $('#flexRigidBoardNo').addClass('active');
    $('#flexRigidBoardNo').removeClass('btn-gray');
    $('#flexRigidBoardYes').removeClass('btn-green');
    $('#flexRigidBoardYes').removeClass('active');
    $('#flexRigidBoardYes').addClass('btn-gray');
  }
  rigidFlexBoardYes(){
    $('#flexRigidBoardYes').addClass('btn-green');
    $('#flexRigidBoardYes').addClass('active');
    $('#flexRigidBoardYes').removeClass('btn-gray');
    $('#flexRigidBoardNo').removeClass('btn-green');
    $('#flexRigidBoardNo').addClass('btn-gray');
    $('#flexRigidBoardNo').removeClass('active');
  }
  silkScreenIsSeclectedYes(){
    $('#silkScreenNo').removeClass('active');
    $('#silkScreenNo').removeClass('btn-green');
    $('#silkScreenNo').addClass('btn-gray');
    $('#silkScreenYes').removeClass('btn-gray');
    $('#silkScreenYes').addClass('active');
    $('#silkScreenYes').addClass('btn-green');
    $('#fabSilkScreenSection').show();
  }
  silkScreenIsSeclectedNo(){
    $('#silkScreenYes').removeClass('active');
    $('#silkScreenYes').removeClass('btn-green');
    $('#silkScreenYes').addClass('btn-gray');
    $('#silkScreenNo').removeClass('btn-gray');
    $('#silkScreenNo').addClass('active');
    $('#silkScreenNo').addClass('btn-green');
    $('#fabSilkScreenSection').hide();
  }
  scoringSelectedYes(){
    $('#scoringNo').removeClass('active');
    $('#scoringNo').removeClass('btn-green');
    $('#scoringNo').addClass('btn-gray');
    $('#scoringYes').removeClass('btn-gray');
    $('#scoringYes').addClass('active');
    $('#scoringYes').addClass('btn-green');
  }
  scoringSelectedNo(){
    $('#scoringYes').removeClass('active');
    $('#scoringYes').removeClass('btn-green');
    $('#scoringYes').addClass('btn-gray');
    $('#scoringNo').removeClass('btn-gray');
    $('#scoringNo').addClass('active');
    $('#scoringNo').addClass('btn-green');
  }
  goldFingerSelectedYes(){
    $('#goldFingersNo').removeClass('active');
    $('#goldFingersNo').removeClass('btn-green');
    $('#goldFingersNo').addClass('btn-gray');
    $('#goldFingersYes').removeClass('btn-gray');
    $('#goldFingersYes').addClass('active');
    $('#goldFingersYes').addClass('btn-green');
  }
  goldFingerSelectedNo(){
    $('#goldFingersYes').removeClass('active');
    $('#goldFingersYes').removeClass('btn-green');
    $('#goldFingersYes').addClass('btn-gray');
    $('#goldFingersNo').removeClass('btn-gray');
    $('#goldFingersNo').addClass('active');
    $('#goldFingersNo').addClass('btn-green');
  }
  roHSMarkingSelectedYes(){
    $('#rohsNo').removeClass('active');
    $('#rohsNo').removeClass('btn-green');
    $('#rohsNo').addClass('btn-gray');
    $('#rohsYes').removeClass('btn-gray');
    $('#rohsYes').addClass('active');
    $('#rohsYes').addClass('btn-green');
  }
  roHSMarkingSelectedNo(){
    $('#rohsYes').removeClass('active');
    $('#rohsYes').removeClass('btn-green');
    $('#rohsYes').addClass('btn-gray');
    $('#rohsNo').removeClass('btn-gray');
    $('#rohsNo').addClass('active');
    $('#rohsNo').addClass('btn-green');
  }
  vendorMarkingSelectedYes(){
    $('#allowVendorMarkingsNo').removeClass('active');
    $('#allowVendorMarkingsNo').removeClass('btn-green');
    $('#allowVendorMarkingsNo').addClass('btn-gray');
    $('#allowVendorMarkingsYes').removeClass('btn-gray');
    $('#allowVendorMarkingsYes').addClass('active');
    $('#allowVendorMarkingsYes').addClass('btn-green');
  }
  vendorMarkingSelectedNo(){
    $('#allowVendorMarkingsYes').removeClass('active');
    $('#allowVendorMarkingsYes').removeClass('btn-green');
    $('#allowVendorMarkingsYes').addClass('btn-gray');
    $('#allowVendorMarkingsNo').removeClass('btn-gray');
    $('#allowVendorMarkingsNo').addClass('active');
    $('#allowVendorMarkingsNo').addClass('btn-green');
  }
  
  counterSinkSelectedYes(){
    $('#counterSinkNo').removeClass('active');
    $('#counterSinkNo').removeClass('btn-green');
    $('#counterSinkNo').addClass('btn-gray');
    $('#counterSinkYes').removeClass('btn-gray');
    $('#counterSinkYes').addClass('active');
    $('#counterSinkYes').addClass('btn-green');
  }
  counterSinkSelectedNo(){
    $('#counterSinkYes').removeClass('active');
    $('#counterSinkYes').removeClass('btn-green');
    $('#counterSinkYes').addClass('btn-gray');
    $('#counterSinkNo').removeClass('btn-gray');
    $('#counterSinkNo').addClass('active');
    $('#counterSinkNo').addClass('btn-green');
  }
  alertCall(title:any,message:any){
    Swal.fire({
      toast: false,
      showConfirmButton: true,
      showCancelButton: false,
      showCloseButton: true,
       allowOutsideClick: false,
      title:title,
      html:message,
      confirmButtonText: 'Ok'
    });
  }

  goToQuotePage(){
    if(this.commonService.commonMainObj.userSessionMemberId != null){
      this.commonService.sessionPortalLoad();
    }
    this.checkAll = false;
    if(!this.boardDetailList.email){
      this.userEmail.nativeElement.focus();
      $('#email').addClass('border-red');
      this.alertCall('Alert!!','Enter your email');
      
      return;
    }else{
      var email = this.boardDetailList.email;
      var emailRegex = /^(?!\.)(?!.*\.\.)[a-zA-Z0-9_.-]{1,64}(?<!\.)@(?!(?:.*-[0-9]+\.){2,})(?=[a-zA-Z0-9-]{1,61}\.)[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,63}$/;
      if (!emailRegex.test(email)) {
        $('.error-message').html('');
        this.userEmail.nativeElement.focus();
        $('#email').addClass('border-red');
        this.alertCall('Alert!!','Please enter a valid Email.');
        return;
      }
    }
    if(this.boardDetailList.layers == "1"){
        $('#NumofLayers').addClass('border-red');
        this.numberofLayers.nativeElement.focus();
        this.alertCall('Alert!!','Please choose the number of layers in your PCB.'); 
        return;
    }
    if( !this.boardDetailList.dimensionX){
      $('#dimensionX').addClass('border-red');
      this.boardDimensionX.nativeElement.focus();
      this.alertCall('Alert!!','Enter value for length');
      return;
    }
    // else if(this.boardDetailList.dimensionX > 15.9 ){
    //   this.alertCall('Alert!!','Individual board X-Dimension and Y-Dimension cannot be greater than 15.9');
    //   $('#dimensionX').addClass('border-red');
    //   return;
    // }else if(this.boardDetailList.dimensionX < 0.5 ){
    //   this.alertCall('Alert!!','Individual board X-Dimension and Y-Dimension cannot be less than 0.5');
    //   $('#dimensionX').addClass('border-red');
    //   return;
    // }
    if( !this.boardDetailList.dimensionY){
      $('#dimensionY').addClass('border-red');
      this.boardDimensionY.nativeElement.focus();
      this.alertCall('Alert!!','Enter value for breadth');
      return;
    }
    // if(this.boardDetailList.dimensionX && this.boardDetailList.dimensionY){
    //   var dimensionArea = (this.boardDetailList.dimensionX) * (this.boardDetailList.dimensionY);
    //   if(dimensionArea  > 150){
    //     this.alertCall('Alert!!','Length * Breadth must be less than 150 sq inch.');
    //     this.boardDetailList.dimensionX ='';
    //     this.boardDetailList.dimensionY ='';
    //     $('#dimensionX').addClass('border-red');
    //     $('#dimensionY').addClass('border-red');
    //     return;
    //   }
    // }
    // else if(this.boardDetailList.dimensionY > 15.9 ){
    //   this.alertCall('Alert!!','Individual board X-Dimension and Y-Dimension cannot be greater than 15.9');
    //   $('#dimensionY').addClass('border-red');
    //   return;
    // }else if(this.boardDetailList.dimensionY < 0.5 ){
    //   this.alertCall('Alert!!','Individual board X-Dimension and Y-Dimension cannot be less than 0.5');
    //   $('#dimensionY').addClass('border-red');
    //   return;
    // }
   
    if($('#boardAsArrayYes').hasClass('active')){
        if(!this.boardDetailList.boardsPerArray){
          $('#boardsPerArray').addClass('border-red');
            this.boardPerArray.nativeElement.focus();
            this.alertCall('Alert!!',"Enter value for 'Boards per array'");
            return;
        }else{
          if(this.boardDetailList.boardsPerArray > 10000){
            $('#boardsPerArray').addClass('border-red');
            this.boardPerArray.nativeElement.focus();
            this.alertCall('Alert!!','Number of boards per array cannot be greater than 10000');
            return;
          }
          if(!this.boardDetailList.arrayDimensionX){
            $('#arrayDimensionX').addClass('border-red');
            this.arrayDimensionX.nativeElement.focus();
            this.alertCall('Alert!!','Enter length for array');
            return;
          }
          if(!this.boardDetailList.arrayDimensionY){
            $('#arrayDimensionY').addClass('border-red');
            this.arrayDimensionY.nativeElement.focus();
            this.alertCall('Alert!!','Enter breadth for array');
            return;
          }
          if(this.boardDetailList.arrayDimensionX != ''  && this.boardDetailList.dimensionX != ''){
            if(parseFloat(this.boardDetailList.arrayDimensionX) < parseFloat(this.boardDetailList.dimensionX)){
              $('#arrayDimensionX').addClass('border-red');
              this.arrayDimensionX.nativeElement.focus();
              this.alertCall('Error!!','Your individual board size does not fit the Array! Please check the dimensions of your Board and/or Array');
              return;
            }
          }
          if(this.boardDetailList.arrayDimensionY  && this.boardDetailList.dimensionY){
            if(parseFloat(this.boardDetailList.arrayDimensionY) < parseFloat(this.boardDetailList.dimensionY)){
              $('#arrayDimensionY').addClass('border-red');
              this.arrayDimensionY.nativeElement.focus();
              this.alertCall('Error!!','Your individual board size does not fit the Array! Please check the dimensions of your Board and/or Array');
              return;
            }
          }  
          // if(this.boardDetailList.arrayDimensionX && this.boardDetailList.arrayDimensionY){
          //   var arrayArea = (this.boardDetailList.arrayDimensionX) * (this.boardDetailList.arrayDimensionY);
          //   console.log("arrayArea",arrayArea);
          //   if(arrayArea  > 150){
          //     this.alertCall('Alert!!','Array area should be less than 150 sq. inches');
          //     this.boardDetailList.arrayDimensionX ='';
          //     this.boardDetailList.arrayDimensionY ='';
          //     $('#arrayDimensionX').addClass('border-red');
          //     $('#arrayDimensionY').addClass('border-red');
          //     return;
          //   }
          // }
          if($('#routeAndRetainNo').hasClass('active') && $('#scoringNo').hasClass('active')){
              this.alertCall('Alert!!','Choose Route and Retain or Scoring if your PCBs are in Arrays');
              return;
          }
          if($('#routeAndRetainYes').hasClass('active') && $('#scoringYes').hasClass('active')){
            this.alertCall('Alert!!',"Both 'Route and Retain' and 'Scoring' cannot be set to 'Yes' together.<br/> Choose either 'Route and Retain' or 'Scoring' ");
            return;
        }
        }
    }
    if( !this.boardDetailList.noOfHolesPerBoard){
      $('#noOfHolesPerBoard').addClass('border-red');
      this.noOfHolesPerBoard.nativeElement.focus();
      this.alertCall('Alert!!','Please enter Number of Holes Per Board.');
      return;
    }
    if(this.boardDetailList.boardsPerArray){
        if((this.boardDetailList.boardQty1 % this.boardDetailList.boardsPerArray != 0) || (this.boardDetailList.boardQty2 % this.boardDetailList.boardsPerArray != 0)){
            this.alertCall('Alert!!','If your boards are in an Array, then Quantity of Boards for quote should be in MULTIPLES of the number of boards per array.E.g.,if you have 4 boards per array, then we can only quote you in multiples of 4 (4, 8, 12, 20, 40..etc.)');
            return;
        }
        // if(this.boardDetailList.boardQty1 == 0 || this.boardDetailList.boardQty2 == 0 || this.boardDetailList.boardQty3 == 0 || this.boardDetailList.boardQty4 == 0){
        if(this.boardDetailList.boardQty1 == '' && this.boardDetailList.boardQty2 == '' ){
          $('#boardQty1').addClass('border-red');
          this.boardQtyOne.nativeElement.focus();
          this.alertCall('Alert!!','Please enter quantity of individual boards');
          return;
        }else if($('#boardQty1').val() == $('#boardQty2').val()){
          $('#boardQty1').addClass('border-red');
          this.boardQtyOne.nativeElement.focus();
          this.alertCall('Alert!!','The quantities entered are duplicates. Kindly input two distinct quantities.');
          return;
        }
    }
    
    if(this.boardDetailList.dimensionX && this.boardDetailList.dimensionY && this.boardDetailList.noOfHolesPerBoard ){
        if(this.boardDetailList.noOfHolesPerBoard  > (this.boardDetailList.dimensionX * this.boardDetailList.dimensionY * 80)){
            // this.alertCall('Alert!!','Number of holes per board cannot be more than 80 holes/square inch');
            // return;
            // this.commonService.commonMainObj.pcbType = "Custom/Advanced PCB";
            // this.commonService.commonMainObj.customQuoteParam = '';
            // this.commonService.commonMainObj.exceededNUmOfHoles = true;
            // this.router.navigateByUrl('/quoteDetails');
        }
    }
    if (!this.commonService.commonMainObj.backToBoardDetails){
      if($('#boardAsArrayYes').hasClass('active')){
          if(this.boardDetailList.dimensionX && this.boardDetailList.dimensionY && this.boardDetailList.noOfHolesPerBoard && this.boardDetailList.boardsPerArray && this.boardDetailList.arrayDimensionX && this.boardDetailList.arrayDimensionY){
              if (!$("input[name='itar']:checked").val() && !(this.commonService.commonMainObj.backToBoardDetails)) {
                $('#itarYes').addClass('border-red');
                $('#itarNo').addClass('border-red');
                // this.itarYes.nativeElement.focus();
                this.alertCall('Alert!!','Please choose whether your design is restricted by ITAR or any Export Control.');
                return;
              }
          }
      }else{
          if(this.boardDetailList.dimensionX && this.boardDetailList.dimensionY && this.boardDetailList.noOfHolesPerBoard ){
              if (!$("input[name='itar']:checked").val() && (!this.commonService.commonMainObj.backToBoardDetails)) {
                $('#itarYes').addClass('border-red');
                $('#itarNo').addClass('border-red');
                // this.itarYes.nativeElement.focus();
                this.alertCall('Alert!!','Please choose whether your design is restricted by ITAR or any Export Control.');
                return;
              }
          }
      }
    }
    if($('#boardQty1').val() == '' && $('#boardQty2').val() == '' && $('#boardQty3').val() == '' && $('#boardQty4').val() == '' ){
      $('#boardQty1').addClass('border-red');
      this.boardQtyOne.nativeElement.focus();
      this.alertCall('Alert!!','Please enter quantity of individual boards');
      return;
    }else if($('#boardQty1').val() == ''){
      $('#boardQty1').addClass('border-red');
      this.boardQtyOne.nativeElement.focus();
      this.alertCall('Alert!!','Please enter quantity of individual boards');
      return;
    }else if($('#boardQty2').val() == ''){
      $('#boardQty2').addClass('border-red');
      this.boardQtyTwo.nativeElement.focus();
      this.alertCall('Alert!!','Please enter quantity of individual boards');
      return;
    }else if($('#boardQty3').val() == ''){
      $('#boardQty3').addClass('border-red');
      this.boardQtyThree.nativeElement.focus();
      this.alertCall('Alert!!','Please enter quantity of individual boards');
      return;
    }else if($('#boardQty4').val() == ''){
      $('#boardQty4').addClass('border-red');
      this.boardQtyFour.nativeElement.focus();
      this.alertCall('Alert!!','Please enter quantity of individual boards');
      return;
    }
    else if($('#boardQty1').val() == $('#boardQty2').val()){
      $('#boardQty1').addClass('border-red');
      this.boardQtyOne.nativeElement.focus();
      this.alertCall('Alert!!','The quantities entered are duplicates. Kindly input two distinct quantities.');
      return;
    }

    this.commonService.commonMainObj.selectedLayerVal = this.boardDetailList.layers - 1;
    // this.boardDetailList.layers = this.boardDetailList.layers-1;
    var minSpaceInInches = this.boardDetailList.minimumSpace;
    this.commonService.commonMainObj.minSpaceSelected  = this.boardDetailList.minimumSpace;
    minSpaceInInches = minSpaceInInches.split(' ')[0] * 0.001;
    var minTraceInInches = this.boardDetailList.minimumTrace;
    this.commonService.commonMainObj.minTraceSelected  = this.boardDetailList.minimumTrace;
    minTraceInInches = minTraceInInches.split(' ')[0] * 0.001;
    var minminHoleSizeInInches = this.boardDetailList.minHoleSize;
    this.commonService.commonMainObj.minHoleSizeSelected = this.boardDetailList.minHoleSize;
    minminHoleSizeInInches = minminHoleSizeInInches.split(' ')[0]*0.001;
    var innerMinSpaceInInches = this.boardDetailList.innerMinimumSpace;
    this.commonService.commonMainObj.minInnerSpaceSelected  = this.commonService.commonMainObj.selectedLayerVal > 2 ? this.boardDetailList.innerMinimumSpace:'Not Applicable';
    innerMinSpaceInInches = innerMinSpaceInInches.split(' ')[0] * 0.001;
    var innerMinTraceInInches = this.boardDetailList.innerMinimumTrace;
    this.commonService.commonMainObj.minInnerTraceSelected  =this.commonService.commonMainObj.selectedLayerVal > 2 ? this.boardDetailList.innerMinimumTrace:'Not Applicable';
    innerMinTraceInInches = innerMinTraceInInches.split(' ')[0] * 0.001;
    var controlledImped  = this.boardDetailList.controlledImpedance;
    this.commonService.commonMainObj.controlledImpedance = this.boardDetailList.controlledImpedance;
    controlledImped  = controlledImped.split(' ')[0];
    this.commonService.commonMainObj.maxBoardQuantity = Math.max(this.boardDetailList.boardQty1, this.boardDetailList.boardQty2);
    this.commonService.commonMainObj.boardDetailsDataObj={
        "arrayXDim": this.boardDetailList.arrayDimensionX?this.boardDetailList.arrayDimensionX:'',
        "arrayYDim":this.boardDetailList.arrayDimensionY?this.boardDetailList.arrayDimensionY:'',
        "boardQty1": this.boardDetailList.boardQty1,
        "boardQty2": this.boardDetailList.boardQty2,
        "boardQty3": this.boardDetailList.boardQty3,
        "boardQty4": this.boardDetailList.boardQty4,
        "arrays": this.boardAsArraySelected ?'Yes':'No',
        "boardsPerArray": this.boardAsArraySelected ? this.boardDetailList.boardsPerArray  : '',
        "controlledDielectric": "No",
        "controlledImpedance": controlledImped,
        "counterBore": "No",
        "edgePlating": "No",
        "electricalTesting": "Yes",
        "finishedThickness": this.boardDetailList.boardThickness,
        "goldFingers": $('#goldFingersYes').hasClass('active')?"Yes":"No",
        "indBoardXDim": this.boardDetailList.dimensionX,
        "indBoardYDim": this.boardDetailList.dimensionY,
        "innerLyrFinishCopper": this.commonService.commonMainObj.selectedLayerVal > 2  ? this.boardDetailList.innerMaxFinishCopperWeight:'Not Applicable',
        "layers": this.commonService.commonMainObj.selectedLayerVal+' Layer',
        "material": this.boardDetailList.boardMaterial,
        "minHoleSize": this.boardDetailList.minHoleSize.split(' ')[0] == '10' ? minminHoleSizeInInches.toFixed(3) + ' inches or more': minminHoleSizeInInches.toFixed(3) + ' Inches',
        "minimumSpace":this.boardDetailList.minimumSpace != 'Other'? minSpaceInInches.toFixed(3) +' Inches' : 'Other',
        "minimumSpaceInnerLyr": this.commonService.commonMainObj.selectedLayerVal > 2 ? this.boardDetailList.innerMinimumSpace != 'Other'?innerMinSpaceInInches.toFixed(3) +' Inches':'Other':'Not Applicable',
        "minimumTrace":this.boardDetailList.minimumTrace != 'Other'? minTraceInInches.toFixed(3) + ' Inches' 
        :'Other',
        "minimumTraceInnerLyr": this.commonService.commonMainObj.selectedLayerVal > 2 ? this.boardDetailList.innerMinimumTrace != 'Other'? innerMinTraceInInches.toFixed(3) + ' Inches':'Other':'Not Applicable',
        "noOfHolesPerBoard": this.boardDetailList.noOfHolesPerBoard,
        "outerLyrFinishCopper":this.boardDetailList.maxFinishCopperWeight,
        "partNumber": this.boardDetailList.partNumber,
        "partRevision": this.boardDetailList.revision,
        "projectID": "",
        "routeAndRetain": $('#routeAndRetainYes').hasClass('active')?"Yes":"No",
        "scoring": $('#scoringYes').hasClass('active')?"Yes":"No",
        "silkScreen": $('#silkScreenYes').hasClass('active')?"Yes":"No",
        "silkScreenColor": $('#silkScreenYes').hasClass('active') ? this.boardDetailList.silkScreenColor : "",
        "silkScreenSides":$('#silkScreenYes').hasClass('active') ? this.boardDetailList.silkScreenSides : "", 
        "slotsCutouts": this.boardDetailList.internalSlotsCutOut,
        "solderMask": $('#solderMaskYes').hasClass('active')?"Yes":"No",
        "solderMaskColor": $('#solderMaskYes').hasClass('active') ? this.boardDetailList.solderMaskColor : "",
        "solderMaskFinish": $('#solderMaskYes').hasClass('active') ? this.boardDetailList.solderMaskFinish : "",
        "solderMaskSides": $('#solderMaskYes').hasClass('active') ? this.boardDetailList.solderMaskSides : "",
        "solderMaskType": $('#solderMaskYes').hasClass('active') ? this.boardDetailList.solderMaskTypes : "",
        "surfaceFinish":  this.boardDetailList.surfaceFinish,
        "thruHoleViainPad": "",
        "itar": $('#itarSitchYes').hasClass('active')?"Yes":"No",
        "vendorMarking": $('#allowVendorMarkingsYes').hasClass('active')?"Yes":"No",
        "roHSMarking": $('#rohsYes').hasClass('active')?"Yes":"No",
        "counterSink": this.commonService.commonMainObj.backToBoardDetails ? $('#counterSinkYes').hasClass('active')?"Yes":"No":this.commonService.commonMainObj.fileUploadedData.boardParam.counterSink,
        "email":this.boardDetailList.email,
        "rigidflexboard":$('#flexRigidBoardYes').hasClass('active')?"Yes":"No",
        "blindburiedvias":$('#blindBuriedBoardYes').hasClass('active')?"Yes":"No"
    }
    this.commonService.commonMainObj.minSpaceInMils = this.boardDetailList.minimumSpace;
    this.commonService.commonMainObj.minTraceInMils = this.boardDetailList.minimumTrace;
    this.commonService.commonMainObj.innerMinSpaceInMils = this.boardDetailList.innerMinimumSpace;
    this.commonService.commonMainObj.innerMinTraceInMils = this.boardDetailList.innerMinimumTrace;
    this.commonService.commonMainObj.minHoleSizeInMils = this.boardDetailList.minHoleSize;
    // console.log("obj",this.commonService.commonMainObj.boardDetailsDataObj);
    this.commonService.commonMainObj.email = this.boardDetailList.email;
    this.commonService.commonMainObj.partNumber = this.boardDetailList.partNumber;
    this.commonService.commonMainObj.partRevision = this.boardDetailList.revision;
    this.commonService.commonMainObj.surfaceFinish = this.boardDetailList.surfaceFinish;
    this.commonService.commonMainObj.material = this.boardDetailList.boardMaterial;
    this.commonService.commonMainObj.indBoardXDim = this.boardDetailList.dimensionX;
    this.commonService.commonMainObj.indBoardYDim = this.boardDetailList.dimensionY;
    this.commonService.commonMainObj.layerValue = this.boardDetailList.layers;
    this.commonService.commonMainObj.itar =  $('#itarSitchYes').hasClass('active')?"Yes":"No";
    this.commonService.loadingShow();
    localStorage.setItem('mid',this.boardDetailList.email);
    this.callToPushFinalSpecifications(this.layersImg,'Number of Layers',this.boardDetailList.layers - 1 + ' Layer');
    this.callToPushFinalSpecifications(this.noOfHolesPerBoardsImg,'Number of Holes (per board)',this.boardDetailList.noOfHolesPerBoard);
    this.callToPushFinalSpecifications(this.boardDimensionImg,'Individual Board Dimensions (inches)',this.boardDetailList.dimensionX +' X '+ this.boardDetailList.dimensionY);
    this.callToPushFinalSpecifications(this.blindBuriedImg,'Blind / Buried vias',$('#blindBuriedBoardYes').hasClass('active')?"Yes":"No");
    this.callToPushFinalSpecifications(this.flexRigidBoardImg,'Flex / Rigid-Flex Board',$('#flexRigidBoardYes').hasClass('active')?"Yes":"No");
    this.callToPushFinalSpecifications(this.boardMaterialImg,'Board Material',this.boardDetailList.boardMaterial);
    this.callToPushFinalSpecifications(this.boardThicknessImg,'Board Thickness',this.boardDetailList.boardThickness);
    this.callToPushFinalSpecifications(this.minHoleSizeImg,'Minimum Hole Size',this.boardDetailList.minHoleSize);
    this.callToPushFinalSpecifications(this.surfaceFinishImg,'Surface Finish',this.boardDetailList.surfaceFinish);
    this.callToPushFinalSpecifications(this.minimumTraceImg,'Minimum Trace',this.boardDetailList.minimumTrace);
    this.callToPushFinalSpecifications(this.minimumSpaceImg,'Minimum Space',this.boardDetailList.minimumSpace);
    this.callToPushFinalSpecifications(this.maxFinishCopperWeightImg,'Maximum Finish Copper Weight', this.boardDetailList.maxFinishCopperWeight);
    this.callToPushFinalSpecifications(this.innerMinimumTraceImg,'Inner Minimum Trace',this.boardDetailList.innerMinimumTrace);
    this.callToPushFinalSpecifications(this.innerMinimumSpaceImg,'Inner Minimum Space',this.boardDetailList.innerMinimumSpace);
    this.callToPushFinalSpecifications(this.innerMaxFinishCopperWeightImg,'Inner Maximum Finish Copper Weight',this.boardDetailList.layers - 1 > 2 ? this.boardDetailList.innerMaxFinishCopperWeight:'Not Applicable');
    this.callToPushFinalSpecifications(this.solderMaskImg,'Solder Mask',$('#solderMaskYes').hasClass('active')?"Yes":"No");
    this.callToPushFinalSpecifications(this.solderMaskSidesImg,'Solder Mask Sides',$('#solderMaskYes').hasClass('active') ? this.boardDetailList.solderMaskSides : "");
    this.callToPushFinalSpecifications(this.solderMaskTypesImg,'Solder Mask Type',$('#solderMaskYes').hasClass('active') ? this.boardDetailList.solderMaskTypes : "");
    this.callToPushFinalSpecifications(this.solderMaskColorImg,'Solder Mask Color',$('#solderMaskYes').hasClass('active') ? this.boardDetailList.solderMaskColor : "");
    this.callToPushFinalSpecifications(this.solderMaskFinishImg,'Solder Mask Finish',$('#solderMaskYes').hasClass('active') ? this.boardDetailList.solderMaskFinish : "");
    this.callToPushFinalSpecifications(this.silkScreenImg,'Silk Screen',$('#silkScreenYes').hasClass('active')?"Yes":"No")
    this.callToPushFinalSpecifications(this.silkScreenSidesImg,'Silk Screen Sides',$('#silkScreenYes').hasClass('active') ? this.boardDetailList.silkScreenSides : "");
    this.callToPushFinalSpecifications(this.silkScreenColorImg,'Silk Screen Color', $('#silkScreenYes').hasClass('active') ? this.boardDetailList.silkScreenColor : "");
    this.callToPushFinalSpecifications(this.internalSlotsCutOutImg,'Internal Slots or Internal Cutouts',this.boardDetailList.internalSlotsCutOut);
    this.callToPushFinalSpecifications(this.controlledImpedanceImg,'Controlled impedance',this.boardDetailList.controlledImpedance);
    this.callToPushFinalSpecifications(this.routeAndRetainImg,'Route and Retain',$('#routeAndRetainYes').hasClass('active')?"Yes":"No");
    this.callToPushFinalSpecifications(this.scoringImg,'Scoring',$('#scoringYes').hasClass('active')?"Yes":"No");
    this.callToPushFinalSpecifications(this.goldFingersImg,'Gold Fingers',$('#goldFingersYes').hasClass('active')?"Yes":"No");
    this.callToPushFinalSpecifications(this.rohsImg,'Allow RoHS Marking',$('#rohsYes').hasClass('active')?"Yes":"No");
    this.callToPushFinalSpecifications(this.counterSinkImg,'Counter Sink',this.commonService.commonMainObj.backToBoardDetails ? $('#CounterSinkYes').hasClass('active')?"Yes":"No":this.commonService.commonMainObj.fileUploadedData.boardParam.counterSink);
    this.callToPushFinalSpecifications(this.allowVendorMarkingImg,'Allow vendor markings on boards',$('#allowVendorMarkingsYes').hasClass('active')?"Yes":"No");
    this.callToPushFinalSpecifications(this.boardAsArrayImg,'Boards setup as an array',$('#boardAsArrayYes').hasClass('active')?"Yes":"No");
    this.callToPushFinalSpecifications(this.quantityOfIndividualBoardsImg ,'Quantity of Individual Boards',this.boardDetailList.boardQty1+','+this.boardDetailList.boardQty2);
    if(this.boardAsArraySelected){
      this.callToPushFinalSpecifications(this.boardsPerArrayImg ,'Boards per array',this.boardDetailList.boardsPerArray);
      this.callToPushFinalSpecifications(this.boardPerArrayDimensionImg ,'Array Dimensions (inches)',this.boardDetailList.arrayDimensionX + ' X ' +this.boardDetailList.arrayDimensionY);
    }
    this.callToPushFinalSpecifications(this.itarSitchImg,'Need ITAR Compliance?',$('#itarSitchYes').hasClass('active')?"Yes":"No");
    this.apiService.getGuestEmailInfo(this.boardDetailList.email).subscribe((guestUserRes:any)=>{
        if(guestUserRes){
            this.commonService.commonMainObj.guestEmailInfo = guestUserRes;
            this.commonService.commonMainObj.userId = guestUserRes.userId;
            this.commonService.commonMainObj.userData.userId = guestUserRes.userId;
            if(guestUserRes.memberId == null && guestUserRes.userId == null){
              this.commonService.commonMainObj.newUser = true;
              this.commonService.commonMainObj.registeredUser = false;
              this.commonService.commonMainObj.defaultEmail = guestUserRes.email;
            }else if(guestUserRes.memberId != null && guestUserRes.userId != null){
              this.commonService.commonMainObj.newUser = false;
              this.commonService.commonMainObj.registeredUser = true;
              this.commonService.commonMainObj.defaultEmail = guestUserRes.email;
            }
            this.apiService.getPcbQuote(this.commonService.commonMainObj.boardDetailsDataObj).subscribe((pebResData: any)=>{
              // this.commonService.loadingHide();
                this.commonService.commonMainObj.noPriceForTurntimeQtyCombination = false;
                this.commonService.commonMainObj.noPriceForAllTurntimeQtyCombination = false;
                if(pebResData){
                  this.commonService.commonMainObj.pcbQuotePriceInfo = pebResData;
                  // console.log("pcbQuotePriceInfo",this.commonService.commonMainObj.pcbQuotePriceInfo);
                  this.commonService.commonMainObj.webPCBQuoteParameters = pebResData.quoteType == "Web PCB" ? pebResData.webPCBQuoteParameters : '';
                  if(pebResData.quoteType == "Web PCB" || pebResData.quoteType == "Product 1" || pebResData.quoteType == "Product 2"){
                    this.commonService.commonMainObj.pcbType = pebResData.quoteType == "Web PCB" ? "Web PCB":pebResData.quoteType == "Product 1"? "Product 1": "Product 2";
                      // this.commonService.commonMainObj.pcbType = "Web PCB";
                      var NoCallUsCnt = 0;
                        this.formatCurrency = (v:any) => {
                          try { return parseFloat(v).toLocaleString('USD', {
                              style: 'currency',
                              currency: "USD",
                              minimumFractionDigits : 2,
                              maximumFractionDigits : 2
                          }) } catch (e) { return v}
                        };
                        let columns = [];
                        columnloop: for (let m of pebResData.pcbPriceMatrix.webQuoteMatrix) {
                            let field = m.turntime;
                            for (let c of columns) if (c.field == field) continue columnloop;
                            columns.push({field: field, title: m.turntime});
                        }
                        let rows = [];
                        let i=0
                        rowloop: for (let m of pebResData.pcbPriceMatrix.webQuoteMatrix) {
                            let turnTimeQuantity = m.quantity ;
                            let row:any;
                            for (let r of rows) {
                                if (r.turnTimeQuantity == turnTimeQuantity) {
                                    row = r;
                                    break;
                                }
                            }
                            if(m.isCallUs == 0){
                              NoCallUsCnt++;
                            }
                            if (!row){
                                rows.push(row = {turnTimeQuantity: turnTimeQuantity });
                            } 
                            row[m.turntime] = m.unitPrice + ',' + m.isCallUs;  
                            i++;
                        }
                        this.commonService.commonMainObj.priceMatrixRowData = rows;
                        this.commonService.commonMainObj.priceMatrixColData = columns;
                        this.commonService.commonMainObj.noPriceForTurntimeQtyCombination = false;
                        // console.log("this.commonService.commonMainObj.priceMatrixColData",this.commonService.commonMainObj.priceMatrixColData);
                        // console.log("this.commonService.commonMainObj.priceMatrixRowData",this.commonService.commonMainObj.priceMatrixRowData);
                        if(NoCallUsCnt > 0){
                          // console.log("pcb flow");
                          this.commonService.commonMainObj.wmqId  = pebResData.wmqId;
                          this.goToQuotePageChecked();
                          // this.router.navigateByUrl('/assemblyProcess');
                      }else{
                        // console.log("custom flow");
                        this.commonService.commonMainObj.noPriceForAllTurntimeQtyCombination = true;
                        this.commonService.commonMainObj.pcbType = "Custom/Advanced PCB";
                        this.commonService.commonMainObj.customQuoteParam = pebResData.customQuoteParameters;
                        // this.router.navigateByUrl('/quoteDetails');
                        this.goToQuotePageChecked();
                      }    
                  }else if(pebResData.quoteType == "Custom/Advanced PCB"){
                    this.commonService.commonMainObj.pcbType = "Custom/Advanced PCB";
                    this.commonService.commonMainObj.customQuoteParam = pebResData.customQuoteParameters;
                    // this.router.navigateByUrl('/quoteDetails');
                    this.goToQuotePageChecked();
                    // this.commonService.loadingHide();
                    // window.scrollTo(0, 0);
                   
                  }
                } 
            },error => {
              this.commonService.loadingHide();
                console.log("Error in getting PCB quote",error);
            });
        }
    },error => {
      this.commonService.loadingHide();
        console.log("Error in getting guest email info",error);
    });
    
    // this.router.navigateByUrl('/quoteDetails');
   
  }


  goToQuotePageChecked(){
    this.commonService.sessionPortalLoad();
    this.commonService.loadingHide();
    if(this.commonService.commonMainObj.userSessionMemberId != null){
      // setTimeout(()=>{
        this.apiService.checkUserSessionApi().subscribe((data: any)=>{
          if(data.status == 1){
            if(this.commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'){
              // this.router.navigateByUrl('/quoteDetails');
              this.commonService.showtoast('Custom Quote Not yet developed.','warning');
            }else{
              this.router.navigateByUrl('/assemblyProcess');
            }
          }
        },error =>{
          console.log('Error in checking user session', error);   
        })
      // },1000);
    }else{
      if(this.commonService.commonMainObj.pcbType == 'Custom/Advanced PCB'){
        // this.router.navigateByUrl('/quoteDetails');
        this.commonService.showtoast('Custom Quote Not yet developed.','warning');
      }else{
        this.router.navigateByUrl('/assemblyProcess');
      }
    }
  }

  callToPushFinalSpecifications(icon:any, param:any, val:any){
    var paramObj={
      "key":param,
      "value":val
    }
    if(val != '' && val != undefined){
      if(icon == "Extracted_icon"){
        this.finalExtractedPcbSpecification.push(paramObj);
      }else if(icon == "Default_icon"){
        this.finalDefaultPcbSpecification.push(paramObj);
      }else if(icon == "Updated_icon"){
        this.finalUpdatedPcbSpecification.push(paramObj);
      }
    }
  }
  showToolTip(labelNum:any){
    $("#boardDetailLabel-"+labelNum).html(this.boardDetailLabeltooltips[labelNum-1].value);
  }
  hideToolTip(labelValue:any){
    $("#boardDetailLabel-"+labelValue).html("");
  }

  showImageToolTip(imgType:any){
    if(imgType == "Default_icon"){
      $('.lableImageLabel-'+imgType).html("Default value");
    }else if(imgType == "Extracted_icon"){
      $('.lableImageLabel-'+imgType).html("Extracted from design file");
    }else if(imgType == "Updated_icon"){
      $('.lableImageLabel-'+imgType).html("User updated value");
    }
    
  }
  hideImageToolTip(imgType:any){
    $('.lableImageLabel-'+imgType).html("");
  }
  populateQuantityInputs(val:any){
    this.boardDetailList.boardQty1 = val*1;
    this.boardDetailList.boardQty2 = val*3;
    this.boardDetailList.boardQty3 = val*5;
    this.boardDetailList.boardQty4 = val*10;
  }

  openViaInPad(content:any) {
    var modalRef = this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',scrollable: true, windowClass : "new-lineItem-class"})
    modalRef.result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return  `with: ${reason}`;
    }
  }

  changeItarToSwitchButtons(event:any){
    if(event.target.checked){
      $('#itarRadioButtonGroup').hide();
      $('#itarSwitchButtonGroup').show();
      if(event.target.id == 'itarYes'){
        $('#itarSitchYes').addClass('btn-green');
        $('#itarSitchYes').addClass('active');
        $('#itarSitchYes').removeClass('btn-gray');
        $('#itarSitchNo').removeClass('btn-green');
        $('#itarSitchNo').addClass('btn-gray');
        $('#itarSitchNo').removeClass('active');
      }else if(event.target.id == 'itarNo'){
        $('#itarSitchNo').addClass('btn-green');
        $('#itarSitchNo').addClass('active');
        $('#itarSitchNo').removeClass('btn-gray');
        $('#itarSitchYes').removeClass('btn-green');
        $('#itarSitchYes').removeClass('active');
        $('#itarSitchYes').addClass('btn-gray');
      }
      this.itarSitchImg = "Updated_icon";
    }else{
      $('#itarRadioButtonGroup').show();
      $('#itarSwitchButtonGroup').hide();

    }
  }

  switchOfButtons(event:any){
    var currentElement = event.target.id;
    var currentElementValue = $('#'+currentElement).val();
    $('#'+currentElement).siblings().removeClass('btn-green');
    $('#'+currentElement).siblings().addClass('btn-gray');
    $('#'+currentElement).addClass('btn-green');
    $('#'+currentElement).removeClass('btn-gray');
    $('#'+currentElement).siblings().removeClass('active');
    $('#'+currentElement).addClass('active');
    if(currentElement == "boardAsArrayYes"){
      this.boardAsArraySelected = true;
      //this.boardAsArrayImg = "Updated_icon";
      //this.boardsPerArrayImg = "Updated_icon";
      $('#boardPerArrayHide').hide();
      $('#boardPerArrayDimensionHide').hide();
    }else if(currentElement == "boardAsArrayNo"){
      this.boardAsArraySelected = false;
      this.boardDetailsForm.get('boardsPerArray')?.reset();
      this.boardDetailsForm.get('arrayDimensionX')?.reset();
      this.boardDetailsForm.get('arrayDimensionY')?.reset();
      //this.boardDetailList.boardsPerArray ='';
      // this.boardDetailList.arrayDimensionX ='';
      // this.boardDetailList.arrayDimensionY ='';
      this.boardDetailList.boardQty1 = '5';
      this.boardDetailList.boardQty2 = '10';
      this.boardDetailList.boardQty3 = '15';
      this.boardDetailList.boardQty4 = '20';
      //this.boardAsArrayImg = "Updated_icon";
      this.quantityOfIndividualBoardsImg = "Default_icon";
    }
    for(var quoteInputGroup of this.productsData.products[0].quoteInputGroups) {
      for(var quoteInput of quoteInputGroup.quoteInputs) {
        if(quoteInput.inputName == "arrays" && (currentElement == "boardAsArrayNo" || currentElement == "boardAsArrayYes")){

          if((quoteInput.default == '0' && currentElementValue == 'No') || (quoteInput.default == '1' && currentElementValue == 'Yes')){
            if(quoteInput.isExtracted){
              this.boardAsArrayImg = "Extracted_icon";
            }else if(!quoteInput.isExtracted){
              this.boardAsArrayImg = "Default_icon";
            }
          }else{
            this.boardAsArrayImg = "Updated_icon";
          }
        }else if(quoteInput.inputName == "flexRigidFlex" && (currentElement == "flexRigidBoardYes" || currentElement == "flexRigidBoardNo")){
          if((quoteInput.default == '0' && currentElementValue == 'No') || (quoteInput.default == '1' && currentElementValue == 'Yes')){
            if(quoteInput.isExtracted){
              this.flexRigidBoardImg = "Extracted_icon";
            }else if(!quoteInput.isExtracted){
              this.flexRigidBoardImg = "Default_icon";
            }
          }else{
            this.flexRigidBoardImg = "Updated_icon";
          }
        }else if(quoteInput.inputName == "blindburiedvias" && (currentElement == "blindBuriedBoardYes" || currentElement == "blindBuriedBoardNo")){
          if((quoteInput.default == '0' && currentElementValue == 'No') || (quoteInput.default == '1' && currentElementValue == 'Yes')){
            if(quoteInput.isExtracted){
              this.blindBuriedImg = "Extracted_icon";
            }else if(!quoteInput.isExtracted){
              this.blindBuriedImg = "Default_icon";
            }
          }else{
            this.blindBuriedImg = "Updated_icon";
          }
        }else if(quoteInput.inputName == "routeAndRetain" && (currentElement == "routeAndRetainYes" || currentElement == "routeAndRetainNo")){
          if((quoteInput.default == '0' && currentElementValue == 'No') || (quoteInput.default == '1' && currentElementValue == 'Yes')){
            if(quoteInput.isExtracted){
              this.routeAndRetainImg = "Extracted_icon";
            }else if(!quoteInput.isExtracted){
              this.routeAndRetainImg = "Default_icon";
            }
          }else{
            this.routeAndRetainImg = "Updated_icon";
          }
        }else if(quoteInput.inputName == "scoring" && (currentElement == "scoringYes" || currentElement == "scoringNo")){
          if((quoteInput.default == '0' && currentElementValue == 'No') || (quoteInput.default == '1' && currentElementValue == 'Yes')){
            if(quoteInput.isExtracted){
              this.scoringImg = "Extracted_icon";
            }else if(!quoteInput.isExtracted){
              this.scoringImg = "Default_icon";
            }
          }else{
            this.scoringImg = "Updated_icon";
          }
        }else if(quoteInput.inputName == "goldFingers" && (currentElement == "goldFingersYes" || currentElement == "goldFingersNo")){
          if((quoteInput.default == '0' && currentElementValue == 'No') || (quoteInput.default == '1' && currentElementValue == 'Yes')){
            if(quoteInput.isExtracted){
              this.goldFingersImg = "Extracted_icon";
            }else if(!quoteInput.isExtracted){
              this.goldFingersImg = "Default_icon";
            }
          }else{
            this.goldFingersImg = "Updated_icon";
          }
        }else if(quoteInput.inputName == "vendorMarking" && (currentElement == "allowVendorMarkingsYes" || currentElement == "allowVendorMarkingsNo")){
          if((quoteInput.default == '0' && currentElementValue == 'No') || (quoteInput.default == '1' && currentElementValue == 'Yes')){
            if(quoteInput.isExtracted){
              this.allowVendorMarkingImg = "Extracted_icon";
            }else if(!quoteInput.isExtracted){
              this.allowVendorMarkingImg = "Default_icon";
            }
          }else{
            this.allowVendorMarkingImg = "Updated_icon";
          }
        }else if(quoteInput.inputName == "solderMask" && (currentElement == "solderMaskYes" || currentElement == "solderMaskNo")){
          if((quoteInput.default == '0' && currentElementValue == 'No') || (quoteInput.default == '1' && currentElementValue == 'Yes')){
            if(quoteInput.isExtracted){
              this.solderMaskImg = "Extracted_icon";
            }else if(!quoteInput.isExtracted){
              this.solderMaskImg = "Default_icon";
            }
          }else{
            this.solderMaskImg = "Updated_icon";
          }
        }else if(quoteInput.inputName == "silkScreen" && (currentElement == "silkScreenYes" || currentElement == "silkScreenNo")){
          if((quoteInput.default == '0' && currentElementValue == 'No') || (quoteInput.default == '1' && currentElementValue == 'Yes')){
            if(quoteInput.isExtracted){
              this.silkScreenImg = "Extracted_icon";
            }else if(!quoteInput.isExtracted){
              this.silkScreenImg = "Default_icon";
            }
          }else{
            this.silkScreenImg = "Updated_icon";
          }
        }
        
      }
    }
    if(currentElement == "itarSitchYes" || currentElement == "itarSitchNo"){
      this.itarSitchImg = "Updated_icon";
    }
    if(currentElement ==  "solderMaskNo"){
      this.solderMaskSeclectedYes = false;
      $('#fabSolderMaskSection').hide();
    }else if(currentElement ==  "solderMaskYes"){
      this.solderMaskSeclectedYes = true;
      $('#fabSolderMaskSection').show();
    }
    if(currentElement ==  "silkScreenNo"){
      this.silkScreenSeclectedYes = false;
      $('#fabSilkScreenSection').hide();
    }else if(currentElement ==  "silkScreenYes"){
      this.silkScreenSeclectedYes = true;
      $('#fabSilkScreenSection').show();
    }
  }
  switchOfRohsButtons(event:any){
    var currentElement = event.target.id;
    var currentElementValue = $('#'+currentElement).val();
    if(currentElement == "rohsYes"){
      $('#rohsNo').removeClass('btn-green');
      $('#rohsNo').addClass('btn-gray');
      $('#rohsYes').addClass('btn-green');
      $('#rohsYes').removeClass('btn-gray');
      $('#rohsNo').removeClass('active');
      $('#rohsYes').addClass('active');
    }else if(currentElement == "rohsNo"){
      $('#rohsYes').removeClass('btn-green');
      $('#rohsYes').addClass('btn-gray');
      $('#rohsNo').addClass('btn-green');
      $('#rohsNo').removeClass('btn-gray');
      $('#rohsYes').removeClass('active');
      $('#rohsNo').addClass('active');
    }
    for(var quoteInputGroup of this.productsData.products[0].quoteInputGroups) {
      for(var quoteInput of quoteInputGroup.quoteInputs) {
        if(quoteInput.inputName == "roHSMarking" && (currentElement == "rohsYes" || currentElement == "rohsNo")){
          if((quoteInput.default == '0' && currentElementValue == 'No') || (quoteInput.default == '1' && currentElementValue == 'Yes')){
            if(quoteInput.isExtracted){
              this.rohsImg = "Extracted_icon";
            }else if(!quoteInput.isExtracted){
              this.rohsImg = "Default_icon";
            }
          }else{
            this.rohsImg = "Updated_icon";
          }
        }
      }
    }
    
  }

  switchOfTestingButtons(event:any){
    var currentElement = event.target.id;
    if(currentElement == "electricalTestingYes"){
      $('#electricalTestingNo').removeClass('btn-green');
      $('#electricalTestingNo').addClass('btn-gray');
      $('#electricalTestingYes').addClass('btn-green');
      $('#electricalTestingYes').removeClass('btn-gray');
      $('#electricalTestingNo').removeClass('active');
      $('#electricalTestingYes').addClass('active');
    }else if(currentElement == "electricalTestingNo"){
      $('#electricalTestingYes').removeClass('btn-green');
      $('#electricalTestingYes').addClass('btn-gray');
      $('#electricalTestingNo').addClass('btn-green');
      $('#electricalTestingNo').removeClass('btn-gray');
      $('#electricalTestingYes').removeClass('active');
      $('#electricalTestingNo').addClass('active');
    }
  }

  switchOfCounterSinkButtons(event:any){
    var currentElement = event.target.id;
    var currentElementValue = $('#'+currentElement).val();
    if(currentElement == "counterSinkYes"){
      $('#counterSinkNo').removeClass('btn-green');
      $('#counterSinkNo').addClass('btn-gray');
      $('#counterSinkYes').addClass('btn-green');
      $('#counterSinkYes').removeClass('btn-gray');
      $('#counterSinkNo').removeClass('active');
      $('#counterSinkYes').addClass('active');
    }else if(currentElement == "counterSinkNo"){
      $('#counterSinkYes').removeClass('btn-green');
      $('#counterSinkYes').addClass('btn-gray');
      $('#counterSinkNo').addClass('btn-green');
      $('#counterSinkNo').removeClass('btn-gray');
      $('#counterSinkYes').removeClass('active');
      $('#counterSinkNo').addClass('active');
    }
    for(var quoteInputGroup of this.productsData.products[0].quoteInputGroups) {
      for(var quoteInput of quoteInputGroup.quoteInputs) {
        if(quoteInput.inputName == "counterSink" && (currentElement == "counterSinkYes" || currentElement == "counterSinkNo")){
          if((quoteInput.default == '0' && currentElementValue == 'No') || (quoteInput.default == '1' && currentElementValue == 'Yes')){
            if(quoteInput.isExtracted){
              this.counterSinkImg = "Extracted_icon";
            }else if(!quoteInput.isExtracted){
              this.counterSinkImg = "Default_icon";
            }
          }else{
            this.counterSinkImg = "Updated_icon";
          }
        }
      }
    }
    
  }

  validationOnlayers(selectedLayer:any){
    this.commonService.commonMainObj.selectedLayerVal = selectedLayer-1;
    selectedLayer = selectedLayer-1;
    console.log("this.commonService.commonMainObj.selectedLayerVal",this.commonService.commonMainObj.selectedLayerVal);
    if(this.commonService.commonMainObj.selectedLayerVal > 6){
      $('#electricalTestingNo').prop("disabled",true);
      $('#testingToolTip').show();
      if($('#electricalTestingNo').hasClass('active')){
        $('#electricalTestingNo').removeClass('active');
        $('#electricalTestingNo').removeClass('btn-green');
        $('#electricalTestingNo').addClass('btn-gray');
        $('#electricalTestingYes').removeClass('btn-gray');
        $('#electricalTestingYes').removeClass('active');
        $('#electricalTestingYes').addClass('btn-green');
      }
    }else{
      $('#electricalTestingNo').prop("disabled",false);
      $('#testingToolTip').hide();
    }
    if(this.commonService.commonMainObj.selectedLayerVal > 2){
      this.hideInnerLayerContent=false;
    }else{
      this.hideInnerLayerContent=true;
    }
    if(this.commonService.commonMainObj.selectedLayerVal < 1){
      $('#numOfLayersIndicateDiv').hide();
    }else if(this.commonService.commonMainObj.selectedLayerVal >= 1){
      $('#numOfLayersIndicateDiv').show();
    }
    for(var quoteInputGroup of this.productsData.products[0].quoteInputGroups) {
      for(var quoteInput of quoteInputGroup.quoteInputs) {
        if(quoteInput.inputName == 'layers'){
          if(quoteInput.default == this.boardDetailList.layers && quoteInput.isExtracted){
            this.layersImg = "Extracted_icon";
          }else if(quoteInput.default == this.boardDetailList.layers && !quoteInput.isExtracted){
            this.layersImg = "Default_icon";
          }else{
            this.layersImg = "Updated_icon";
          }
        }
      }
    }
  }

  changeInSelectInput(event:any){
    var currentElement = event.target.id;
    var currentElementValue = $('#'+currentElement).val();
    console.log("ChangedValue", currentElementValue);
    for(var quoteInputGroup of this.productsData.products[0].quoteInputGroups) {
      for(var quoteInput of quoteInputGroup.quoteInputs) {
        if(quoteInput.inputName == "material" && (currentElement == "boardMaterial")){
          for (var vm in quoteInput.valueMap) {
            if(quoteInput.default == vm){
              var defaultValue = quoteInput.valueMap[vm];
              if(defaultValue == currentElementValue && quoteInput.isExtracted){
                this.boardMaterialImg = "Extracted_icon";
              }else if(defaultValue == currentElementValue && !quoteInput.isExtracted){
                this.boardMaterialImg = "Default_icon";
              }else{
                this.boardMaterialImg = "Updated_icon";
              }
            }
          }
        }else if(quoteInput.inputName == "minHoleSize" && (currentElement == "minHoleSize")){
          for (var vm in quoteInput.valueMap) {
            if(quoteInput.default == vm){
              var defaultValue = quoteInput.valueMap[vm];
              if(defaultValue == currentElementValue && quoteInput.isExtracted){
                this.minHoleSizeImg = "Extracted_icon";
              }else if(defaultValue == currentElementValue && !quoteInput.isExtracted){
                this.minHoleSizeImg = "Default_icon";
              }else{
                this.minHoleSizeImg = "Updated_icon";
              }
            }
          }
        }else if(quoteInput.inputName == "surfaceFinish" && (currentElement == "surfaceFinish")){
          for (var vm in quoteInput.valueMap) {
            if(quoteInput.default == vm){
              var defaultValue = quoteInput.valueMap[vm];
              if(defaultValue == currentElementValue && quoteInput.isExtracted){
                this.surfaceFinishImg = "Extracted_icon";
              }else if(defaultValue == currentElementValue && !quoteInput.isExtracted){
                this.surfaceFinishImg = "Default_icon";
              }else{
                this.surfaceFinishImg = "Updated_icon";
              }
            }
          }
        }else if(quoteInput.inputName == "finishedThickness" && (currentElement == "boardThickness")){
          for (var vm in quoteInput.valueMap) {
            if(quoteInput.default == vm){
              var defaultValue = quoteInput.valueMap[vm];
              if(defaultValue == currentElementValue && quoteInput.isExtracted){
                this.boardThicknessImg = "Extracted_icon";
              }else if(defaultValue == currentElementValue && !quoteInput.isExtracted){
                this.boardThicknessImg = "Default_icon";
              }else{
                this.boardThicknessImg = "Updated_icon";
              }
            }
          }
        }else if(quoteInput.inputName == "minimumTrace" && (currentElement == "minimumTrace")){
          for (var vm in quoteInput.valueMap) {
            if(quoteInput.default == vm){
              var defaultValue = quoteInput.valueMap[vm];
              if(defaultValue == currentElementValue && quoteInput.isExtracted){
                this.minimumTraceImg = "Extracted_icon";
              }else if(defaultValue == currentElementValue && !quoteInput.isExtracted){
                this.minimumTraceImg = "Default_icon";
              }else{
                this.minimumTraceImg = "Updated_icon";
              }
            }
          }
        }else if(quoteInput.inputName == "outerLyrFinishCopper" && (currentElement == "maxFinishCopperWeight")){
          for (var vm in quoteInput.valueMap) {
            if(quoteInput.default == vm){
              var defaultValue = quoteInput.valueMap[vm];
              if(defaultValue == currentElementValue && quoteInput.isExtracted){
                this.maxFinishCopperWeightImg = "Extracted_icon";
              }else if(defaultValue == currentElementValue && !quoteInput.isExtracted){
                this.maxFinishCopperWeightImg = "Default_icon";
              }else{
                this.maxFinishCopperWeightImg = "Updated_icon";
              }
            }
          }
        }else if(quoteInput.inputName == "minimumSpace" && (currentElement == "minimumSpace")){
          for (var vm in quoteInput.valueMap) {
            if(quoteInput.default == vm){
              var defaultValue = quoteInput.valueMap[vm];
              if(defaultValue == currentElementValue && quoteInput.isExtracted){
                this.minimumSpaceImg = "Extracted_icon";
              }else if(defaultValue == currentElementValue && !quoteInput.isExtracted){
                this.minimumSpaceImg = "Default_icon";
              }else{
                this.minimumSpaceImg = "Updated_icon";
              }
            }
          }
        }else if(quoteInput.inputName == "minimumTraceInnerLyr" && (currentElement == "innerMinimumTrace")){
          this.boardDetailList.innerMinimumTrace = currentElementValue;
          for (var vm in quoteInput.valueMap) {
            if(quoteInput.default == vm){
              var defaultValue = quoteInput.valueMap[vm];
              if(defaultValue == currentElementValue && quoteInput.isExtracted){
                this.innerMinimumTraceImg = "Extracted_icon";
              }else if(defaultValue == currentElementValue && !quoteInput.isExtracted){
                this.innerMinimumTraceImg = "Default_icon";
              }else{
                this.innerMinimumTraceImg = "Updated_icon";
              }
            }
          }
        }else if(quoteInput.inputName == "innerLyrFinishCopper" && (currentElement == "innerMaxFinishCopperWeight")){
          for (var vm in quoteInput.valueMap) {
            if(quoteInput.default == vm){
              var defaultValue = quoteInput.valueMap[vm];
              if(defaultValue == currentElementValue && quoteInput.isExtracted){
                this.innerMaxFinishCopperWeightImg = "Extracted_icon";
              }else if(defaultValue == currentElementValue && !quoteInput.isExtracted){
                this.innerMaxFinishCopperWeightImg = "Default_icon";
              }else{
                this.innerMaxFinishCopperWeightImg = "Updated_icon";
              }
            }
          }
        }else if(quoteInput.inputName == "minimumSpaceInnerLyr" && (currentElement == "innerMinimumSpace")){
          // commenting below line for OFP-978
          // this.boardDetailList.innerMinimumTrace = currentElementValue;
          for (var vm in quoteInput.valueMap) {
            if(quoteInput.default == vm){
              var defaultValue = quoteInput.valueMap[vm];
              if(defaultValue == currentElementValue && quoteInput.isExtracted){
                this.innerMinimumSpaceImg = "Extracted_icon";
              }else if(defaultValue == currentElementValue && !quoteInput.isExtracted){
                this.innerMinimumSpaceImg = "Default_icon";
              }else{
                this.innerMinimumSpaceImg = "Updated_icon";
              }
            }
          }
        }else if(quoteInput.inputName == "solderMaskSides" && (currentElement == "solderMaskSides")){
          for (var vm in quoteInput.valueMap) {
            if(quoteInput.default == vm){
              var defaultValue = quoteInput.valueMap[vm];
              if(defaultValue == currentElementValue && quoteInput.isExtracted){
                this.solderMaskSidesImg = "Extracted_icon";
              }else if(defaultValue == currentElementValue && !quoteInput.isExtracted){
                this.solderMaskSidesImg = "Default_icon";
              }else{
                this.solderMaskSidesImg = "Updated_icon";
              }
            }
          }
        }else if(quoteInput.inputName == "solderMaskColor" && (currentElement == "solderMaskColor")){
          for (var vm in quoteInput.valueMap) {
            if(quoteInput.default == vm){
              var defaultValue = quoteInput.valueMap[vm];
              if(defaultValue == currentElementValue && quoteInput.isExtracted){
                this.solderMaskColorImg = "Extracted_icon";
              }else if(defaultValue == currentElementValue && !quoteInput.isExtracted){
                this.solderMaskColorImg = "Default_icon";
              }else{
                this.solderMaskColorImg = "Updated_icon";
              }
            }else if(quoteInput.default == null){
              if(currentElementValue == 'Green' && quoteInput.isExtracted){
                this.solderMaskColorImg = "Extracted_icon";
              }else if(currentElementValue == 'Green' && !quoteInput.isExtracted){
                this.solderMaskColorImg = "Default_icon";
              }else{
                this.solderMaskColorImg = "Updated_icon";
              }
            }
          }
        }else if(quoteInput.inputName == "solderMaskType" && (currentElement == "solderMaskTypes")){
          for (var vm in quoteInput.valueMap) {
            if(quoteInput.default == vm){
              var defaultValue = quoteInput.valueMap[vm];
              if(defaultValue == currentElementValue && quoteInput.isExtracted){
                this.solderMaskTypesImg = "Extracted_icon";
              }else if(defaultValue == currentElementValue && !quoteInput.isExtracted){
                this.solderMaskTypesImg = "Default_icon";
              }else{
                this.solderMaskTypesImg = "Updated_icon";
              }
            }
          }
        }else if(quoteInput.inputName == "solderMaskFinish" && (currentElement == "solderMaskFinish")){
          for (var vm in quoteInput.valueMap) {
            if(quoteInput.default == vm){
              var defaultValue = quoteInput.valueMap[vm];
              if(defaultValue == currentElementValue && quoteInput.isExtracted){
                this.solderMaskFinishImg = "Extracted_icon";
              }else if(defaultValue == currentElementValue && !quoteInput.isExtracted){
                this.solderMaskFinishImg = "Default_icon";
              }else{
                this.solderMaskFinishImg = "Updated_icon";
              }
            }
          }
        }else if(quoteInput.inputName == "silkScreenSides" && (currentElement == "silkScreenSides")){
          for (var vm in quoteInput.valueMap) {
            if(quoteInput.default == vm){
              var defaultValue = quoteInput.valueMap[vm];
              if(defaultValue == currentElementValue && quoteInput.isExtracted){
                this.silkScreenSidesImg = "Extracted_icon";
              }else if(defaultValue == currentElementValue && !quoteInput.isExtracted){
                this.silkScreenSidesImg = "Default_icon";
              }else{
                this.silkScreenSidesImg = "Updated_icon";
              }
            }else if(quoteInput.default == null){
              if(currentElementValue == 'Both' && quoteInput.isExtracted){
                this.silkScreenSidesImg = "Extracted_icon";
              }else if(currentElementValue == 'Both' && !quoteInput.isExtracted){
                this.silkScreenSidesImg = "Default_icon";
              }else{
                this.silkScreenSidesImg = "Updated_icon";
              }
            }
          }
        }else if(quoteInput.inputName == "silkScreenColor" && (currentElement == "silkScreenColor")){
          for (var vm in quoteInput.valueMap) {
            if(quoteInput.default == vm){
              var defaultValue = quoteInput.valueMap[vm];
              if(defaultValue == currentElementValue && quoteInput.isExtracted){
                this.silkScreenColorImg = "Extracted_icon";
              }else if(defaultValue == currentElementValue && !quoteInput.isExtracted){
                this.silkScreenColorImg = "Default_icon";
              }else{
                this.silkScreenColorImg = "Updated_icon";
              }
            }else if(quoteInput.default == null){
              if(currentElementValue == 'White' && quoteInput.isExtracted){
                this.silkScreenColorImg = "Extracted_icon";
              }else if(currentElementValue == 'White' && !quoteInput.isExtracted){
                this.silkScreenColorImg = "Default_icon";
              }else{
                this.silkScreenColorImg = "Updated_icon";
              }
            }
          }
        }else if(quoteInput.inputName == "controlledImpedance" && (currentElement == "controlledImpedance")){
          for (var vm in quoteInput.valueMap) {
            if(quoteInput.default == vm){
              var defaultValue = quoteInput.valueMap[vm];
              if(defaultValue == currentElementValue && quoteInput.isExtracted){
                this.controlledImpedanceImg = "Extracted_icon";
              }else if(defaultValue == currentElementValue && !quoteInput.isExtracted){
                this.controlledImpedanceImg = "Default_icon";
              }else{
                this.controlledImpedanceImg = "Updated_icon";
              }
            }
          }
        }else if(quoteInput.inputName == "slotsCutouts" && (currentElement == "internalSlotsCutOut")){
          for (var vm in quoteInput.valueMap) {
            if(quoteInput.default == vm){
              var defaultValue = quoteInput.valueMap[vm];
              if(defaultValue == currentElementValue && quoteInput.isExtracted){
                this.internalSlotsCutOutImg = "Extracted_icon";
              }else if(defaultValue == currentElementValue && !quoteInput.isExtracted){
                this.internalSlotsCutOutImg = "Default_icon";
              }else{
                this.internalSlotsCutOutImg = "Updated_icon";
              }
            }
          }
        }
        //Select input change check completed here
        //Text Inputs start change check start from Here
        if(quoteInput.inputName == 'indBoardXDim' && currentElement == 'dimensionX'){
          if(quoteInput.default == currentElementValue && this.boardDetailList.dimensionY == this.indBoardDefaultYDim && quoteInput.isExtracted){
            this.boardDimensionImg = "Extracted_icon";
          }else if(quoteInput.default == currentElementValue && this.boardDetailList.dimensionY == this.indBoardDefaultYDim && !quoteInput.isExtracted){
            this.boardDimensionImg = "Default_icon";
          }else{
            this.boardDimensionImg = "Updated_icon";
          }
          $('#IndividualDimensionLableHide').show();
        }else if(quoteInput.inputName == 'indBoardYDim' && currentElement == 'dimensionY'){
          if(quoteInput.default == currentElementValue && this.boardDetailList.dimensionX == this.indBoardDefaultXDim && quoteInput.isExtracted){
            this.boardDimensionImg = "Extracted_icon";
          }else if(quoteInput.default == currentElementValue && this.boardDetailList.dimensionX == this.indBoardDefaultXDim && !quoteInput.isExtracted){
            this.boardDimensionImg = "Default_icon";
          }else{
            this.boardDimensionImg = "Updated_icon";
          }
          $('#IndividualDimensionLableHide').show();
        }else if(quoteInput.inputName == 'arrayXDim' && currentElement == 'arrayDimensionX'){
          if(quoteInput.default == currentElementValue && this.boardDetailList.arrayDimensionY == this.arrayDefaultYDim && quoteInput.isExtracted){
            this.boardPerArrayDimensionImg = "Extracted_icon";
          }else if(quoteInput.default == currentElementValue && this.boardDetailList.arrayDimensionY == this.arrayDefaultYDim && !quoteInput.isExtracted){
            this.boardPerArrayDimensionImg = "Default_icon";
          }else{
            this.boardPerArrayDimensionImg = "Updated_icon";
          }

          if(currentElementValue != '' && this.arrayDefaultYDim != ''){
            $('#boardPerArrayDimensionHide').show();
          }else{
            $('#boardPerArrayDimensionHide').hide();
          }
        }else if(quoteInput.inputName == 'arrayYDim' && currentElement == 'arrayDimensionY'){
          if(quoteInput.default == currentElementValue && this.boardDetailList.arrayDimensionX == this.arrayDefaultXDim && quoteInput.isExtracted){
            this.boardPerArrayDimensionImg = "Extracted_icon";
          }else if(quoteInput.default == currentElementValue && this.boardDetailList.arrayDimensionX == this.arrayDefaultXDim && !quoteInput.isExtracted){
            this.boardPerArrayDimensionImg = "Default_icon";
          }else{
            this.boardPerArrayDimensionImg = "Updated_icon";
          }

          if(currentElementValue != '' && this.arrayDefaultXDim != ''){
            $('#boardPerArrayDimensionHide').show();
          }else{
            $('#boardPerArrayDimensionHide').hide();
          }
        }else if(quoteInput.inputName == 'boardsPerArray' && currentElement == 'boardsPerArray'){
          if(quoteInput.default == currentElementValue && quoteInput.isExtracted){
            this.boardsPerArrayImg = "Extracted_icon";
          }else if(quoteInput.default == currentElementValue && !quoteInput.isExtracted){
            this.boardsPerArrayImg = "Default_icon";
          }else{
            this.boardsPerArrayImg = "Updated_icon";
          }

          if(currentElementValue != null && currentElementValue != ''){
            $('#boardPerArrayHide').show();
          }else{
            $('#boardPerArrayHide').hide();
          }
        }else if(quoteInput.inputName == 'noOfHolesPerBoard' && currentElement == 'noOfHolesPerBoard'){
          if(quoteInput.default == currentElementValue && quoteInput.isExtracted){
            this.noOfHolesPerBoardsImg = "Extracted_icon";
          }else if(quoteInput.default == currentElementValue && !quoteInput.isExtracted){
            this.noOfHolesPerBoardsImg = "Default_icon";
          }else{
            this.noOfHolesPerBoardsImg = "Updated_icon";
          }

          if(currentElementValue != null && currentElementValue != ''){
            $('#numberOfHolesTotipHide').show();
          }else{
            $('#numberOfHolesTotipHide').hide();
          }
        }else if(quoteInput.inputName == 'drillHolesDensity' && currentElement == 'density'){
          if(quoteInput.default == currentElementValue && quoteInput.isExtracted){
            this.densityImg = "Extracted_icon";
          }else if(quoteInput.default == currentElementValue && !quoteInput.isExtracted){
            this.densityImg = "Default_icon";
          }else{
            this.densityImg = "Updated_icon";
          }

          if(currentElementValue != null && currentElementValue != ''){
            $('#densityTooltip').show();
          }else{
            $('#densityTooltip').hide();
          }
        }else if(quoteInput.inputName == 'drillHolesMinimumAnnularRing' && currentElement == 'minAnnularRing'){
          if(quoteInput.default == currentElementValue && quoteInput.isExtracted){
            this.minAnnularRingImg = "Extracted_icon";
          }else if(quoteInput.default == currentElementValue && !quoteInput.isExtracted){
            this.minAnnularRingImg = "Default_icon";
          }else{
            this.minAnnularRingImg = "Updated_icon";
          }

          if(currentElementValue != null && currentElementValue != ''){
            $('#minAnnularRingTooltip').show();
          }else{
            $('#minAnnularRingTooltip').hide();
          }
        }else if(quoteInput.inputName == 'slots' && currentElement == 'internalSlotsCutOutCount'){
          if(quoteInput.default == currentElementValue && quoteInput.isExtracted){
            this.internalSlotsCutOutCountImg = "Extracted_icon";
          }else if(quoteInput.default == currentElementValue && !quoteInput.isExtracted){
            this.internalSlotsCutOutCountImg = "Default_icon";
          }else{
            this.internalSlotsCutOutCountImg = "Updated_icon";
          }

          if(currentElementValue != null && currentElementValue != ''){
            $('#internalSlotsCutOutCountTooltip').show();
          }else{
            $('#internalSlotsCutOutCountTooltip').hide();
          }
        }else if(quoteInput.inputName == 'boardQty1' && currentElement == 'boardQty1'){
          if(this.boardDefaultQty1 == currentElementValue && this.boardDetailList.boardQty2 == this.boardDefaultQty2 && this.boardDetailList.boardQty3 == this.boardDefaultQty3 && this.boardDetailList.boardQty4 == this.boardDefaultQty4 && quoteInput.isExtracted){
            this.quantityOfIndividualBoardsImg = "Extracted_icon";
          }else if(this.boardDefaultQty1 == currentElementValue && this.boardDetailList.boardQty2 == this.boardDefaultQty2 && this.boardDetailList.boardQty3 == this.boardDefaultQty3 && this.boardDetailList.boardQty4 == this.boardDefaultQty4 && !quoteInput.isExtracted){
            this.quantityOfIndividualBoardsImg = "Default_icon";
          }else{
            this.quantityOfIndividualBoardsImg = "Updated_icon";
          }

          if(currentElementValue != null && currentElementValue != ''){
            $('#quantityOfIndividualBoardsImgHide').show();
          }else{
            $('#quantityOfIndividualBoardsImgHide').hide();
          }
        }else if(quoteInput.inputName == 'boardQty2' && currentElement == 'boardQty2'){
          if(this.boardDefaultQty2 == currentElementValue && this.boardDetailList.boardQty1 == this.boardDefaultQty1 && this.boardDetailList.boardQty3 == this.boardDefaultQty3 && this.boardDetailList.boardQty4 == this.boardDefaultQty4 && quoteInput.isExtracted){
            this.quantityOfIndividualBoardsImg = "Extracted_icon";
          }else if(this.boardDefaultQty2 == currentElementValue && this.boardDetailList.boardQty1 == this.boardDefaultQty1 && this.boardDetailList.boardQty3 == this.boardDefaultQty3 && this.boardDetailList.boardQty4 == this.boardDefaultQty4 && !quoteInput.isExtracted){
            this.quantityOfIndividualBoardsImg = "Default_icon";
          }else{
            this.quantityOfIndividualBoardsImg = "Updated_icon";
          }

          if(currentElementValue != null && currentElementValue != ''){
            $('#quantityOfIndividualBoardsImgHide').show();
          }else{
            $('#quantityOfIndividualBoardsImgHide').hide();
          }
        }else if(quoteInput.inputName == 'boardQty3' && currentElement == 'boardQty3'){
          if(this.boardDefaultQty3 == currentElementValue && this.boardDetailList.boardQty1 == this.boardDefaultQty1 && this.boardDetailList.boardQty2 == this.boardDefaultQty2 && this.boardDetailList.boardQty4 == this.boardDefaultQty4 && quoteInput.isExtracted){
            this.quantityOfIndividualBoardsImg = "Extracted_icon";
          }else if(this.boardDefaultQty3 == currentElementValue && this.boardDetailList.boardQty1 == this.boardDefaultQty1 && this.boardDetailList.boardQty2 == this.boardDefaultQty2 && this.boardDetailList.boardQty4 == this.boardDefaultQty4 && !quoteInput.isExtracted){
            this.quantityOfIndividualBoardsImg = "Default_icon";
          }else{
            this.quantityOfIndividualBoardsImg = "Updated_icon";
          }

          if(currentElementValue != null && currentElementValue != ''){
            $('#quantityOfIndividualBoardsImgHide').show();
          }else{
            $('#quantityOfIndividualBoardsImgHide').hide();
          }
        }else if(quoteInput.inputName == 'boardQty4' && currentElement == 'boardQty4'){
          if(this.boardDefaultQty4 == currentElementValue && this.boardDetailList.boardQty1 == this.boardDefaultQty1 && this.boardDetailList.boardQty2 == this.boardDefaultQty2 && this.boardDetailList.boardQty3 == this.boardDefaultQty3 && quoteInput.isExtracted){
            this.quantityOfIndividualBoardsImg = "Extracted_icon";
          }else if(this.boardDefaultQty4 == currentElementValue && this.boardDetailList.boardQty1 == this.boardDefaultQty1 && this.boardDetailList.boardQty2 == this.boardDefaultQty2 && this.boardDetailList.boardQty3 == this.boardDefaultQty3 && !quoteInput.isExtracted){
            this.quantityOfIndividualBoardsImg = "Default_icon";
          }else{
            this.quantityOfIndividualBoardsImg = "Updated_icon";
          }

          if(currentElementValue != null && currentElementValue != ''){
            $('#quantityOfIndividualBoardsImgHide').show();
          }else{
            $('#quantityOfIndividualBoardsImgHide').hide();
          }
        }
      }
    }
  }

  removeRedBorder(id:any,event:any,val:any){
    var uInput = event.target.value;
    // Remove any non-numeric characters
    event.target.value = uInput.replace(/[^0-9]/g, '');
    val = event.target.value;
    // if(id == 'boardQty1'){
    //   this.boardDetailList.boardQty1 = val;
    //   if($('#'+id).val() != ''){
    //     $('#'+id).removeClass('border-red');
    //   }else if($('#boardQty2').val() == ''){
    //     $('#'+id).addClass('border-red');
    //     this.boardQtyOne.nativeElement.focus();
    //   }
    // }
    // if(id == 'boardQty2'){
    //   this.boardDetailList.boardQty2 = val;
    //   if($('#boardQty1').val() == '' && $('#boardQty2').val() == ''){
    //     $('#boardQty1').addClass('border-red');
    //     this.boardQtyOne.nativeElement.focus();
    //   }else if($('#boardQty2').val() == ''){
    //     $('#boardQty2').addClass('border-red');
    //     this.boardQtyTwo.nativeElement.focus();
    //   }else if($('#boardQty2').val() != ''){
    //     $('#boardQty2').removeClass('border-red');
    //     $('#boardQty1').removeClass('border-red');
    //   }
    // }
    
      if(id == 'boardQty1'){
        this.boardDetailList.boardQty1 = val;
          if($('#boardQty1').val() == '' && $('#boardQty2').val() == '' && $('#boardQty3').val() == '' && $('#boardQty4').val() == ''){
          $('#boardQty1').addClass('border-red');
          this.boardQtyOne.nativeElement.focus();
        }else if($('#boardQty1').val() == ''){
          $('#boardQty1').addClass('border-red');
          this.boardQtyOne.nativeElement.focus();
        }else if($('#boardQty2').val() == ''){
          $('#boardQty2').addClass('border-red');
          this.boardQtyTwo.nativeElement.focus();
        }else if($('#boardQty3').val() == ''){
          $('#boardQty3').addClass('border-red');
          this.boardQtyThree.nativeElement.focus();
        }else if($('#boardQty4').val() == ''){
          $('#boardQty4').addClass('border-red');
          this.boardQtyFour.nativeElement.focus();
        }else if($('#boardQty1').val() != '' && $('#boardQty2').val() != '' && $('#boardQty3').val() != '' && $('#boardQty4').val() != '' ){
          $('#boardQty1').removeClass('border-red');
          $('#boardQty2').removeClass('border-red');
          $('#boardQty3').removeClass('border-red');
          $('#boardQty4').removeClass('border-red');
        }
      }else if(id == 'boardQty2'){
        this.boardDetailList.boardQty2 = val;
        if($('#boardQty1').val() == '' && $('#boardQty2').val() == '' && $('#boardQty3').val() == '' && $('#boardQty4').val() == ''){
        $('#boardQty1').addClass('border-red');
        this.boardQtyOne.nativeElement.focus();
        }else if($('#boardQty2').val() == ''){
          $('#boardQty2').addClass('border-red');
          this.boardQtyTwo.nativeElement.focus();
        }else if($('#boardQty1').val() == ''){
          $('#boardQty2').addClass('border-red');
          this.boardQtyOne.nativeElement.focus();
        }else if($('#boardQty3').val() == ''){
          $('#boardQty3').addClass('border-red');
          this.boardQtyThree.nativeElement.focus();
        }else if($('#boardQty4').val() == ''){
          $('#boardQty4').addClass('border-red');
          this.boardQtyFour.nativeElement.focus();
        }else if($('#boardQty1').val() != '' && $('#boardQty2').val() != '' && $('#boardQty3').val() != '' && $('#boardQty4').val() != '' ){
          $('#boardQty1').removeClass('border-red');
          $('#boardQty2').removeClass('border-red');
          $('#boardQty3').removeClass('border-red');
          $('#boardQty4').removeClass('border-red');
        }
      }else if(id == 'boardQty3'){
        this.boardDetailList.boardQty3 = val;
        if($('#boardQty1').val() == '' && $('#boardQty2').val() == '' && $('#boardQty3').val() == '' && $('#boardQty4').val() == ''){
        $('#boardQty1').addClass('border-red');
        this.boardQtyOne.nativeElement.focus();
        }else if($('#boardQty3').val() == ''){
          $('#boardQty3').addClass('border-red');
          this.boardQtyThree.nativeElement.focus();
        }else if($('#boardQty1').val() == ''){
          $('#boardQty1').addClass('border-red');
          this.boardQtyOne.nativeElement.focus();
        }else if($('#boardQty2').val() == ''){
          $('#boardQty2').addClass('border-red');
          this.boardQtyTwo.nativeElement.focus();
        }else if($('#boardQty4').val() == ''){
          $('#boardQty4').addClass('border-red');
          this.boardQtyFour.nativeElement.focus();
        }else if($('#boardQty1').val() != '' && $('#boardQty2').val() != '' && $('#boardQty3').val() != '' && $('#boardQty4').val() != '' ){
          $('#boardQty1').removeClass('border-red');
          $('#boardQty2').removeClass('border-red');
          $('#boardQty3').removeClass('border-red');
          $('#boardQty4').removeClass('border-red');
        }
      }else if(id == 'boardQty4'){
        this.boardDetailList.boardQty4 = val;
        if($('#boardQty1').val() == '' && $('#boardQty2').val() == '' && $('#boardQty3').val() == '' && $('#boardQty4').val() == ''){
        $('#boardQty1').addClass('border-red');
        this.boardQtyOne.nativeElement.focus();
        }else if($('#boardQty4').val() == ''){
          $('#boardQty4').addClass('border-red');
          this.boardQtyFour.nativeElement.focus();
        }else if($('#boardQty1').val() == ''){
          $('#boardQty1').addClass('border-red');
          this.boardQtyOne.nativeElement.focus();
        }else if($('#boardQty2').val() == ''){
          $('#boardQty2').addClass('border-red');
          this.boardQtyTwo.nativeElement.focus();
        }else if($('#boardQty3').val() == ''){
          $('#boardQty3').addClass('border-red');
          this.boardQtyThree.nativeElement.focus();
        }else if($('#boardQty1').val() != '' && $('#boardQty2').val() != '' && $('#boardQty3').val() != '' && $('#boardQty4').val() != '' ){
          $('#boardQty1').removeClass('border-red');
          $('#boardQty2').removeClass('border-red');
          $('#boardQty3').removeClass('border-red');
          $('#boardQty4').removeClass('border-red');
        }
      }
      
    if(id == 'arrayDimensionX'){
      if($('#arrayDimensionX').val() == ''){
        $('#arrayDimensionX').addClass('border-red');
      }else{
        $('#arrayDimensionX').removeClass('border-red');
      }
    }
    if(id == 'arrayDimensionY'){
      if($('#arrayDimensionY').val() == ''){
        $('#arrayDimensionY').addClass('border-red');
      }else{
        $('#arrayDimensionY').removeClass('border-red');
      }
    }
  }
  onlyNumberKey(evt:any){
    // let ASCIICode = (evt.which) ? evt.which : evt.keyCode
    //         if (ASCIICode > 31 && (ASCIICode < 48 || ASCIICode > 57))
    //             return false;
    //         return true;
  }

  onDecimalInput(event: any): void {
    const inputElement = event.target as HTMLInputElement;
    const value = inputElement.value;
    const regex = /^-?\d*(\.\d{0,3})?$/;
    if (!regex.test(value)) {
      inputElement.value = value.slice(0, -1);
    }
  }

  truncateToThreeDecimals(value:any,data:any){
    if (!Number.isInteger(value)) {
      const valueString = value.toString();
      const decimalPart = valueString.split('.')[1];
      if (decimalPart && decimalPart.length > 3) {
        if(data == "this.boardDetailList.dimensionX"){
          this.boardDetailList.dimensionX = parseFloat(valueString.split('.')[0] + '.' + decimalPart.substring(0, 3));
        }
        if(data == "this.boardDetailList.dimensionY"){
          this.boardDetailList.dimensionY = parseFloat(valueString.split('.')[0] + '.' + decimalPart.substring(0, 3));
        }
      }
    }else{
      if(data == "this.boardDetailList.dimensionX"){
        this.boardDetailList.dimensionX = value;
      }
      if(data == "this.boardDetailList.dimensionY"){
        this.boardDetailList.dimensionY = value;
      }
    }
  }
}



